// Мои искренние соболезнования тому, кто сюда полезет
// Мое уважение и почтение тому, кто возьмется это переписывать

/**
 * Compiled inline version. (Library mode)
 */

(function (exports) {
	"use strict";

	const modules = {};

	function require(ids, callback) {
		let module,
			defs = [];

		for (let i = 0; i < ids.length; ++i) {
			module = modules[ids[i]] || resolve(ids[i]);
			if (!module) {
				throw "module definition dependecy not found: " + ids[i];
			}

			defs.push(module);
		}

		callback.apply(null, defs);
	}

	function define(id, dependencies, definition) {
		if (typeof id !== "string") {
			throw "invalid module definition, module id must be defined and be a string";
		}

		if (dependencies === undefined) {
			throw "invalid module definition, dependencies must be specified";
		}

		if (definition === undefined) {
			throw "invalid module definition, definition function must be specified";
		}

		require(dependencies, function () {
			modules[id] = definition.apply(null, arguments);
		});
	}

	function defined(id) {
		return !!modules[id];
	}

	function resolve(id) {
		let target = exports;
		const fragments = id.split(/[.\/]/);

		for (let fi = 0; fi < fragments.length; ++fi) {
			if (!target[fragments[fi]]) {
				return;
			}

			target = target[fragments[fi]];
		}

		return target;
	}

	function expose(ids) {
		let i, target, id, fragments, privateModules;

		for (i = 0; i < ids.length; i++) {
			target = exports;
			id = ids[i];
			fragments = id.split(/[.\/]/);

			for (let fi = 0; fi < fragments.length - 1; ++fi) {
				if (target[fragments[fi]] === undefined) {
					target[fragments[fi]] = {};
				}

				target = target[fragments[fi]];
			}

			target[fragments[fragments.length - 1]] = modules[id];
		}

		// Expose private modules for unit tests
		if (exports.AMDLC_TESTS) {
			privateModules = exports.privateModules || {};

			for (id in modules) {
				privateModules[id] = modules[id];
			}

			for (i = 0; i < ids.length; i++) {
				delete privateModules[ids[i]];
			}

			exports.privateModules = privateModules;
		}
	}

	// Included from: js/tinymce/plugins/table/classes/Utils.js

	/**
	 * Utils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */

	/**
	 * Various utility functions.
	 * @class tinymce.tableplugin.Utils
	 * @private
	 */
	define("tinymce/tableplugin/Utils", ["tinymce/Env"], function (Env) {
		const setSpanVal = function (name) {
			return function (td, val) {
				if (td) {
					val = parseInt(val, 10);

					if (val === 1 || val === 0) {
						td.removeAttribute(name, 1);
					} else {
						td.setAttribute(name, val, 1);
					}
				}
			};
		};

		const getSpanVal = function (name) {
			return function (td) {
				return parseInt(td.getAttribute(name) || 1, 10);
			};
		};

		function paddCell(cell) {
			if (!Env.ie || Env.ie > 9) {
				if (!cell.hasChildNodes()) {
					cell.innerHTML = '<br data-mce-bogus="1" />';
				}
			}
		}

		return {
			setColSpan: setSpanVal("colSpan"),
			setRowSpan: setSpanVal("rowspan"),
			getColSpan: getSpanVal("colSpan"),
			getRowSpan: getSpanVal("rowSpan"),
			setSpanVal: function (td, name, value) {
				setSpanVal(name)(td, value);
			},
			getSpanVal: function (td, name) {
				return getSpanVal(name)(td);
			},
			paddCell: paddCell,
		};
	});

	// Included from: js/tinymce/plugins/table/classes/SplitCols.js

	/**
	 * SplitCols.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */

	/**
	 * Contains logic for handling splitting of merged rows.
	 * @class tinymce.tableplugin.SplitCols
	 * @private
	 */
	define("tinymce/tableplugin/SplitCols", ["tinymce/util/Tools", "tinymce/tableplugin/Utils"], function (Tools, Utils) {
		const getCellAt = function (grid, x, y) {
			return grid[y] ? grid[y][x] : null;
		};

		const getCellElmAt = function (grid, x, y) {
			const cell = getCellAt(grid, x, y);
			return cell ? cell.elm : null;
		};

		const countHoles = function (grid, x, y, delta) {
			let y2,
				cell,
				count = 0,
				elm = getCellElmAt(grid, x, y);

			for (y2 = y; delta > 0 ? y2 < grid.length : y2 >= 0; y2 += delta) {
				cell = getCellAt(grid, x, y2);
				if (elm !== cell.elm) {
					break;
				}

				count++;
			}

			return count;
		};

		const findRealElm = function (grid, x, y) {
			let cell,
				row = grid[y];

			for (let x2 = x; x2 < row.length; x2++) {
				cell = row[x2];
				if (cell.real) {
					return cell.elm;
				}
			}

			return null;
		};

		const getRowSplitInfo = function (grid, y) {
			let cell,
				result = [],
				row = grid[y];

			for (let x = 0; x < row.length; x++) {
				cell = row[x];
				result.push({
					elm: cell.elm,
					above: countHoles(grid, x, y, -1) - 1,
					below: countHoles(grid, x, y, 1) - 1,
				});

				x += Utils.getColSpan(cell.elm) - 1;
			}

			return result;
		};

		const createCell = function (info, rowSpan) {
			const doc = info.elm.ownerDocument;
			const newCell = doc.createElement("td");

			Utils.setColSpan(newCell, Utils.getColSpan(info.elm));
			Utils.setRowSpan(newCell, rowSpan);
			Utils.paddCell(newCell);

			return newCell;
		};

		const insertOrAppendCell = function (grid, newCell, x, y) {
			let realCellElm = findRealElm(grid, x + 1, y);

			if (!realCellElm) {
				realCellElm = findRealElm(grid, 0, y);
				realCellElm.parentNode.appendChild(newCell);
			} else {
				realCellElm.parentNode.insertBefore(newCell, realCellElm);
			}
		};

		const splitAbove = function (grid, info, x, y) {
			if (info.above !== 0) {
				Utils.setRowSpan(info.elm, info.above);
				const cell = createCell(info, info.below + 1);
				insertOrAppendCell(grid, cell, x, y);
				return cell;
			}

			return null;
		};

		const splitBelow = function (grid, info, x, y) {
			if (info.below !== 0) {
				Utils.setRowSpan(info.elm, info.above + 1);
				const cell = createCell(info, info.below);
				insertOrAppendCell(grid, cell, x, y + 1);
				return cell;
			}

			return null;
		};

		const splitAt = function (grid, x, y, before) {
			const rowInfos = getRowSplitInfo(grid, y);
			const rowElm = getCellElmAt(grid, x, y).parentNode;
			const cells = [];

			Tools.each(rowInfos, function (info, x) {
				const cell = before ? splitAbove(grid, info, x, y) : splitBelow(grid, info, x, y);
				if (cell !== null) {
					cells.push(cells);
				}
			});

			return {
				cells: cells,
				row: rowElm,
			};
		};

		return {
			splitAt: splitAt,
		};
	});

	// Included from: js/tinymce/plugins/table/classes/TableGrid.js

	/**
	 * TableGrid.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */

	/**
	 * This class creates a grid out of a table element. This
	 * makes it a whole lot easier to handle complex tables with
	 * col/row spans.
	 * @class tinymce.tableplugin.TableGrid
	 * @private
	 */
	define("tinymce/tableplugin/TableGrid", [
		"tinymce/util/Tools",
		"tinymce/Env",
		"tinymce/tableplugin/Utils",
		"tinymce/tableplugin/SplitCols",
	], function (Tools, Env, Utils, SplitCols) {
		const each = Tools.each,
			getSpanVal = Utils.getSpanVal,
			setSpanVal = Utils.setSpanVal;

		return function (editor, table, selectedCell) {
			let grid,
				gridWidth,
				startPos,
				endPos,
				selection = editor.selection,
				dom = selection.dom;

			function removeCellSelection() {
				editor.$("td[data-mce-selected],th[data-mce-selected]").removeAttr("data-mce-selected");
			}

			function isEditorBody(node) {
				return node === editor.getBody();
			}

			function getChildrenByName(node, names) {
				if (!node) {
					return [];
				}

				names = Tools.map(names.split(","), function (name) {
					return name.toLowerCase();
				});

				return Tools.grep(node.childNodes, function (node) {
					return Tools.inArray(names, node.nodeName.toLowerCase()) !== -1;
				});
			}

			function buildGrid() {
				let startY = 0;

				grid = [];
				gridWidth = 0;

				each(["thead", "tbody", "tfoot"], function (part) {
					const partElm = getChildrenByName(table, part)[0];
					const rows = getChildrenByName(partElm, "tr");

					each(rows, function (tr, y) {
						y += startY;

						each(getChildrenByName(tr, "td,th"), function (td, x) {
							let x2, y2, rowspan, colspan;

							// Skip over existing cells produced by rowspan
							if (grid[y]) {
								while (grid[y][x]) {
									x++;
								}
							}

							// Get col/rowspan from cell
							rowspan = getSpanVal(td, "rowspan");
							colspan = getSpanVal(td, "colspan");

							// Fill out rowspan/colspan right and down
							for (y2 = y; y2 < y + rowspan; y2++) {
								if (!grid[y2]) {
									grid[y2] = [];
								}

								for (x2 = x; x2 < x + colspan; x2++) {
									grid[y2][x2] = {
										part: part,
										real: y2 === y && x2 === x,
										elm: td,
										rowspan: rowspan,
										colspan: colspan,
									};
								}
							}

							gridWidth = Math.max(gridWidth, x + 1);
						});
					});

					startY += rows.length;
				});
			}

			function fireNewRow(node) {
				editor.fire("newrow", {
					node: node,
				});

				return node;
			}

			function fireNewCell(node) {
				editor.fire("newcell", {
					node: node,
				});

				return node;
			}

			function cloneNode(node, children) {
				node = node.cloneNode(children);
				node.removeAttribute("id");

				return node;
			}

			function getCell(x, y) {
				let row;

				row = grid[y];
				if (row) {
					return row[x];
				}
			}

			function getRow(grid, y) {
				return grid[y] ? grid[y] : null;
			}

			function getColumn(grid, x) {
				const out = [];

				for (let y = 0; y < grid.length; y++) {
					out.push(getCell(x, y));
				}

				return out;
			}

			function isCellSelected(cell) {
				return cell && (!!dom.getAttrib(cell.elm, "data-mce-selected") || cell === selectedCell);
			}

			function getSelectedRows() {
				const rows = [];

				each(table.rows, function (row) {
					each(row.cells, function (cell) {
						if (dom.getAttrib(cell, "data-mce-selected") || (selectedCell && cell === selectedCell.elm)) {
							rows.push(row);
							return false;
						}
					});
				});

				return rows;
			}

			function countSelectedCols() {
				let cols = 0;

				each(grid, function (row) {
					each(row, function (cell) {
						if (isCellSelected(cell)) {
							cols++;
						}
					});
					if (cols) {
						return false;
					}
				});

				return cols;
			}

			function deleteTable() {
				const rng = dom.createRng();

				if (isEditorBody(table)) {
					return;
				}

				rng.setStartAfter(table);
				rng.setEndAfter(table);

				selection.setRng(rng);

				dom.remove(table);
			}

			function cloneCell(cell) {
				let formatNode,
					cloneFormats = {};

				if (editor.settings.table_clone_elements !== false) {
					cloneFormats = Tools.makeMap(
						(editor.settings.table_clone_elements || "strong em b i span font h1 h2 h3 h4 h5 h6 p div").toUpperCase(),
						/[ ,]/
					);
				}

				// Clone formats
				Tools.walk(
					cell,
					function (node) {
						let curNode;

						if (node.nodeType === 3) {
							each(dom.getParents(node.parentNode, null, cell).reverse(), function (node) {
								if (!cloneFormats[node.nodeName]) {
									return;
								}

								node = cloneNode(node, false);

								if (!formatNode) {
									formatNode = curNode = node;
								} else if (curNode) {
									curNode.appendChild(node);
								}

								curNode = node;
							});

							// Add something to the inner node
							if (curNode) {
								curNode.innerHTML = Env.ie && Env.ie < 10 ? "&nbsp;" : '<br data-mce-bogus="1" />';
							}

							return false;
						}
					},
					"childNodes"
				);

				cell = cloneNode(cell, false);
				fireNewCell(cell);

				setSpanVal(cell, "rowSpan", 1);
				setSpanVal(cell, "colSpan", 1);

				if (formatNode) {
					cell.appendChild(formatNode);
				} else {
					Utils.paddCell(cell);
				}

				return cell;
			}

			function cleanup() {
				let rng = dom.createRng(),
					row;

				// Empty rows
				each(dom.select("tr", table), function (tr) {
					if (tr.cells.length === 0) {
						dom.remove(tr);
					}
				});

				// ищем объединённые ячейки и сортировки, если всё есть - грохаем сортировку
				each(dom.select("table"), function (table) {
					if (!table) return;
					let sorting = false,
						rowspan = 0,
						colspan = 0;
					each(dom.select("td, th", table), function (td) {
						rowspan += parseInt(td.getAttribute("rowspan") || 0);
						colspan += parseInt(td.getAttribute("colspan") || 0);
						sorting = "TSP_sortCol".indexOf(td.classList) > -1 ? true : sorting;
					});

					if (colspan + rowspan > 0 && sorting) {
						each(dom.select("td, th", table), function (cell) {
							cell.classList.remove("TSP_sortCol");
							if (cell.classList.length === 0) cell.removeAttribute("class");
						});
						table.classList.remove("TSP_hasSort");
						if (table.classList.length === 0) table.removeAttribute("class");
					}
				});

				// Empty table
				if (table && dom.select("tr", table).length === 0) {
					rng.setStartBefore(table);
					rng.setEndBefore(table);
					selection.setRng(rng);
					dom.remove(table);
					return;
				}

				// Empty header/body/footer
				each(dom.select("thead,tbody,tfoot", table), function (part) {
					if (part.rows.length === 0) {
						dom.remove(part);
					}
				});

				// Restore selection to start position if it still exists
				buildGrid();

				// If we have a valid startPos object
				if (startPos) {
					// Restore the selection to the closest table position
					row = grid[Math.min(grid.length - 1, startPos.y)];
					if (row) {
						selection.select(row[Math.min(row.length - 1, startPos.x)].elm, true);
						selection.collapse(true);
					}
				}
			}

			function fillLeftDown(x, y, rows, cols) {
				let tr, x2, r, c, cell;

				tr = grid[y][x].elm.parentNode;
				for (r = 1; r <= rows; r++) {
					tr = dom.getNext(tr, "tr");

					if (tr) {
						// Loop left to find real cell
						for (x2 = x; x2 >= 0; x2--) {
							cell = grid[y + r][x2].elm;

							if (cell.parentNode === tr) {
								// Append clones after
								for (c = 1; c <= cols; c++) {
									dom.insertAfter(cloneCell(cell), cell);
								}

								break;
							}
						}

						if (x2 === -1) {
							// Insert nodes before first cell
							for (c = 1; c <= cols; c++) {
								tr.insertBefore(cloneCell(tr.cells[0]), tr.cells[0]);
							}
						}
					}
				}
			}

			function split() {
				each(grid, function (row, y) {
					each(row, function (cell, x) {
						let colSpan, rowSpan, i;

						if (isCellSelected(cell)) {
							cell = cell.elm;
							colSpan = getSpanVal(cell, "colspan");
							rowSpan = getSpanVal(cell, "rowspan");

							if (colSpan > 1 || rowSpan > 1) {
								setSpanVal(cell, "rowSpan", 1);
								setSpanVal(cell, "colSpan", 1);

								// Insert cells right
								for (i = 0; i < colSpan - 1; i++) {
									dom.insertAfter(cloneCell(cell), cell);
								}

								fillLeftDown(x, y, rowSpan - 1, colSpan);
							}
						}
					});
				});
			}

			function findItemsOutsideOfRange(items, start, end) {
				const out = [];

				for (let i = 0; i < items.length; i++) {
					if (i < start || i > end) {
						out.push(items[i]);
					}
				}

				return out;
			}

			function getFakeCells(cells) {
				return Tools.grep(cells, function (cell) {
					return cell.real === false;
				});
			}

			function getUniqueElms(cells) {
				const elms = [];

				for (let i = 0; i < cells.length; i++) {
					const elm = cells[i].elm;
					if (elms[elms.length - 1] !== elm) {
						elms.push(elm);
					}
				}

				return elms;
			}

			function reduceRowSpans(grid, startX, startY, endX, endY) {
				let count = 0;

				if (endY - startY < 1) {
					return 0;
				}

				for (let y = startY + 1; y <= endY; y++) {
					const allCells = findItemsOutsideOfRange(getRow(grid, y), startX, endX);
					const fakeCells = getFakeCells(allCells);

					if (allCells.length === fakeCells.length) {
						Tools.each(getUniqueElms(fakeCells), function (elm) {
							Utils.setRowSpan(elm, Utils.getRowSpan(elm) - 1);
						});

						count++;
					}
				}

				return count;
			}

			function reduceColSpans(grid, startX, startY, endX, endY) {
				let count = 0;

				if (endX - startX < 1) {
					return 0;
				}

				for (let x = startX + 1; x <= endX; x++) {
					const allCells = findItemsOutsideOfRange(getColumn(grid, x), startY, endY);
					const fakeCells = getFakeCells(allCells);

					if (allCells.length === fakeCells.length) {
						Tools.each(getUniqueElms(fakeCells), function (elm) {
							Utils.setColSpan(elm, Utils.getColSpan(elm) - 1);
						});

						count++;
					}
				}

				return count;
			}

			function merge(cell, cols, rows) {
				let pos, startX, startY, endX, endY, x, y, startCell, endCell, children, count, reducedRows, reducedCols;

				// Use specified cell and cols/rows
				if (cell) {
					pos = getPos(cell);
					startX = pos.x;
					startY = pos.y;
					endX = startX + (cols - 1);
					endY = startY + (rows - 1);
				} else {
					startPos = endPos = null;

					// Calculate start/end pos by checking for selected cells in grid works better with context menu
					each(grid, function (row, y) {
						each(row, function (cell, x) {
							if (isCellSelected(cell)) {
								if (!startPos) {
									startPos = { x: x, y: y };
								}

								endPos = { x: x, y: y };
							}
						});
					});

					// Use selection, but make sure startPos is valid before accessing
					if (startPos) {
						startX = startPos.x;
						startY = startPos.y;
						endX = endPos.x;
						endY = endPos.y;
					}
				}

				// Find start/end cells
				startCell = getCell(startX, startY);
				endCell = getCell(endX, endY);

				// Check if the cells exists and if they are of the same part for example tbody = tbody
				if (startCell && endCell && startCell.part === endCell.part) {
					// Split and rebuild grid
					split();
					buildGrid();

					reducedRows = reduceRowSpans(grid, startX, startY, endX, endY);
					reducedCols = reduceColSpans(grid, startX, startY, endX, endY);

					// Set row/col span to start cell
					startCell = getCell(startX, startY).elm;
					let colSpan = endX - startX - reducedCols + 1;
					let rowSpan = endY - startY - reducedRows + 1;

					// All cells in table selected then just make it a table with one cell
					if (colSpan === gridWidth && rowSpan === grid.length) {
						colSpan = 1;
						rowSpan = 1;
					}

					// Multiple whole rows selected then just make it one rowSpan
					if (colSpan === gridWidth && rowSpan > 1) {
						rowSpan = 1;
					}

					setSpanVal(startCell, "colSpan", colSpan);
					setSpanVal(startCell, "rowSpan", rowSpan);

					// Remove other cells and add it's contents to the start cell
					for (y = startY; y <= endY; y++) {
						for (x = startX; x <= endX; x++) {
							if (!grid[y] || !grid[y][x]) {
								continue;
							}

							cell = grid[y][x].elm;

							/*jshint loopfunc:true */
							/*eslint no-loop-func:0 */
							if (cell !== startCell) {
								// Move children to startCell
								children = Tools.grep(cell.childNodes);
								each(children, function (node) {
									startCell.appendChild(node);
								});

								// Remove bogus nodes if there is children in the target cell
								if (children.length) {
									children = Tools.grep(startCell.childNodes);
									count = 0;
									each(children, function (node) {
										if (node.nodeName === "BR" && count++ < children.length - 1) {
											startCell.removeChild(node);
										}
									});
								}

								dom.remove(cell);
							}
						}
					}

					// Remove empty rows etc and restore caret location
					cleanup();
				}
			}

			function deleteCell(cell) {
				const pos = getPos(cell);
				const colNum = pos.x;
				const rowNum = pos.y;

				if (rowNum === grid.length - 1) {
					cell.parentNode.insertBefore(cloneCell(cell), cell);
					dom.remove(cell);
					buildGrid();
				} else {
					for (let i = rowNum + 1; i < grid.length; i++) {
						let newCell = grid[i][colNum].elm;
						newCell.parentNode.insertBefore(cloneCell(newCell), newCell);
						dom.replace(grid[i][colNum].elm, grid[i - 1][colNum].elm);
						buildGrid();
					}
				}
			}

			function insertRow(before) {
				let posY, cell, lastCell, x, rowElm, newRow, newCell, otherCell, rowSpan, spanValue;

				// Find first/last row
				each(grid, function (row, y) {
					each(row, function (cell) {
						if (isCellSelected(cell)) {
							cell = cell.elm;
							rowElm = cell.parentNode;
							newRow = fireNewRow(cloneNode(rowElm, false));
							posY = y;

							if (before) {
								return false;
							}
						}
					});

					if (before) {
						return posY === undefined;
					}
				});

				// If posY is undefined there is nothing for us to do here...just return to avoid crashing below
				if (posY === undefined) {
					return;
				}

				for (x = 0, spanValue = 0; x < grid[0].length; x += spanValue) {
					// Cell not found could be because of an invalid table structure
					if (!grid[posY][x]) {
						continue;
					}

					cell = grid[posY][x].elm;
					spanValue = getSpanVal(cell, "colspan");

					if (cell !== lastCell) {
						if (!before) {
							rowSpan = getSpanVal(cell, "rowspan");
							if (rowSpan > 1) {
								setSpanVal(cell, "rowSpan", rowSpan + 1);
								continue;
							}
						} else {
							// Check if cell above can be expanded
							if (posY > 0 && grid[posY - 1][x]) {
								otherCell = grid[posY - 1][x].elm;
								rowSpan = getSpanVal(otherCell, "rowSpan");
								if (rowSpan > 1) {
									setSpanVal(otherCell, "rowSpan", rowSpan + 1);
									continue;
								}
							}
						}

						// Insert new cell into new row
						newCell = cloneCell(cell);
						setSpanVal(newCell, "colSpan", cell.colSpan);

						newRow.appendChild(newCell);

						lastCell = cell;
					}
				}
				if (newRow.hasChildNodes()) {
					if (!before) {
						dom.insertAfter(newRow, rowElm);
					} else {
						rowElm.parentNode.insertBefore(newRow, rowElm);
					}
				}
			}

			function insertRows(before, num) {
				num = num || getSelectedRows().length || 1;
				for (let i = 0; i < num; i++) {
					insertRow(before);
				}
			}

			function insertCol(before) {
				let posX, lastCell;

				// Find first/last column
				each(grid, function (row) {
					each(row, function (cell, x) {
						if (isCellSelected(cell)) {
							posX = x;

							if (before) {
								return false;
							}
						}
					});

					if (before) {
						return posX === undefined;
					}
				});

				each(grid, function (row, y) {
					let cell, rowSpan, colSpan;

					if (!row[posX]) {
						return;
					}

					cell = row[posX].elm;
					if (cell !== lastCell) {
						colSpan = getSpanVal(cell, "colspan");
						rowSpan = getSpanVal(cell, "rowspan");

						if (colSpan === 1) {
							if (!before) {
								dom.insertAfter(cloneCell(cell), cell);
								fillLeftDown(posX, y, rowSpan - 1, colSpan);
							} else {
								cell.parentNode.insertBefore(cloneCell(cell), cell);
								fillLeftDown(posX, y, rowSpan - 1, colSpan);
							}
						} else {
							setSpanVal(cell, "colSpan", cell.colSpan + 1);
						}

						lastCell = cell;
					}
				});
			}

			function insertCols(before, num) {
				num = num || countSelectedCols() || 1;
				for (let i = 0; i < num; i++) {
					insertCol(before);
				}
			}

			function getSelectedCells(grid) {
				return Tools.grep(getAllCells(grid), isCellSelected);
			}

			function getAllCells(grid) {
				const cells = [];

				each(grid, function (row) {
					each(row, function (cell) {
						cells.push(cell);
					});
				});

				return cells;
			}

			function deleteCols() {
				const cols = [];

				if (isEditorBody(table)) {
					if (grid[0].length === 1) {
						return;
					}

					if (getSelectedCells(grid).length === getAllCells(grid).length) {
						return;
					}
				}

				// Get selected column indexes
				each(grid, function (row) {
					each(row, function (cell, x) {
						if (isCellSelected(cell) && Tools.inArray(cols, x) === -1) {
							each(grid, function (row) {
								let cell = row[x].elm,
									colSpan;

								colSpan = getSpanVal(cell, "colSpan");

								if (colSpan > 1) {
									setSpanVal(cell, "colSpan", colSpan - 1);
								} else {
									dom.remove(cell);
								}
							});

							cols.push(x);
						}
					});
				});

				cleanup();
			}

			function colsHeader() {
				const cols = [];

				if (isEditorBody(table)) {
					if (grid[0].length === 1) {
						return;
					}

					if (getSelectedCells(grid).length === getAllCells(grid).length) {
						return;
					}
				}

				// Get selected column indexes
				each(grid, function (row) {
					each(row, function (cell, x) {
						if (isCellSelected(cell) && Tools.inArray(cols, x) === -1) {
							each(grid, function (row) {
								let cell = row[x].elm,
									colSpan;

								colSpan = getSpanVal(cell, "colSpan");

								if (colSpan > 1) {
									setSpanVal(cell, "colSpan", colSpan - 1);
								} else {
									dom.remove(cell);
								}
							});

							cols.push(x);
						}
					});
				});

				cleanup();
			}

			function deleteRows() {
				let rows;

				function deleteRow(tr) {
					let pos, lastCell;

					// Move down row spanned cells
					each(tr.cells, function (cell) {
						const rowSpan = getSpanVal(cell, "rowSpan");

						if (rowSpan > 1) {
							setSpanVal(cell, "rowSpan", rowSpan - 1);
							pos = getPos(cell);
							fillLeftDown(pos.x, pos.y, 1, 1);
						}
					});

					// Delete cells
					pos = getPos(tr.cells[0]);
					each(grid[pos.y], function (cell) {
						let rowSpan;

						cell = cell.elm;

						if (cell !== lastCell) {
							rowSpan = getSpanVal(cell, "rowSpan");

							if (rowSpan <= 1) {
								dom.remove(cell);
							} else {
								setSpanVal(cell, "rowSpan", rowSpan - 1);
							}

							lastCell = cell;
						}
					});
				}

				// Get selected rows and move selection out of scope
				rows = getSelectedRows();

				if (isEditorBody(table) && rows.length === table.rows.length) {
					return;
				}

				// Delete all selected rows
				each(rows.reverse(), function (tr) {
					deleteRow(tr);
				});

				cleanup();
			}

			function cutRows() {
				const rows = getSelectedRows();

				if (isEditorBody(table) && rows.length === table.rows.length) {
					return;
				}

				dom.remove(rows);
				cleanup();

				return rows;
			}

			function copyRows() {
				const rows = getSelectedRows();

				each(rows, function (row, i) {
					rows[i] = cloneNode(row, true);
				});

				return rows;
			}

			function pasteRows(rows, before) {
				let splitResult, targetRow, newRows;

				// Nothing to paste
				if (!rows) {
					return;
				}

				splitResult = SplitCols.splitAt(grid, startPos.x, startPos.y, before);
				targetRow = splitResult.row;
				Tools.each(splitResult.cells, fireNewCell);

				newRows = Tools.map(rows, function (row) {
					return row.cloneNode(true);
				});

				if (!before) {
					newRows.reverse();
				}

				each(newRows, function (row) {
					let i,
						cellCount = row.cells.length,
						cell;

					fireNewRow(row);

					// Remove col/rowspans
					for (i = 0; i < cellCount; i++) {
						cell = row.cells[i];

						fireNewCell(cell);
						setSpanVal(cell, "colSpan", 1);
						setSpanVal(cell, "rowSpan", 1);
					}

					// Needs more cells
					for (i = cellCount; i < gridWidth; i++) {
						row.appendChild(fireNewCell(cloneCell(row.cells[cellCount - 1])));
					}

					// Needs less cells
					for (i = gridWidth; i < cellCount; i++) {
						dom.remove(row.cells[i]);
					}

					// Add before/after
					if (before) {
						targetRow.parentNode.insertBefore(row, targetRow);
					} else {
						dom.insertAfter(row, targetRow);
					}
				});

				removeCellSelection();
			}

			function getPos(target) {
				let pos;

				each(grid, function (row, y) {
					each(row, function (cell, x) {
						if (cell.elm === target) {
							pos = { x: x, y: y };
							return false;
						}
					});

					return !pos;
				});

				return pos;
			}

			function setStartCell(cell) {
				startPos = getPos(cell);
			}

			function findEndPos() {
				let maxX, maxY;

				maxX = maxY = 0;

				each(grid, function (row, y) {
					each(row, function (cell, x) {
						let colSpan, rowSpan;

						if (isCellSelected(cell)) {
							cell = grid[y][x];

							if (x > maxX) {
								maxX = x;
							}

							if (y > maxY) {
								maxY = y;
							}

							if (cell.real) {
								colSpan = cell.colspan - 1;
								rowSpan = cell.rowspan - 1;

								if (colSpan) {
									if (x + colSpan > maxX) {
										maxX = x + colSpan;
									}
								}

								if (rowSpan) {
									if (y + rowSpan > maxY) {
										maxY = y + rowSpan;
									}
								}
							}
						}
					});
				});

				return { x: maxX, y: maxY };
			}

			function setEndCell(cell) {
				let startX, startY, endX, endY, maxX, maxY, colSpan, rowSpan, x, y;

				endPos = getPos(cell);

				if (startPos && endPos) {
					// Get start/end positions
					startX = Math.min(startPos.x, endPos.x);
					startY = Math.min(startPos.y, endPos.y);
					endX = Math.max(startPos.x, endPos.x);
					endY = Math.max(startPos.y, endPos.y);

					// Expand end position to include spans
					maxX = endX;
					maxY = endY;

					// This logic tried to expand the selection to always be a rectangle
					// Expand startX
					/*for (y = startY; y <= maxY; y++) {
					cell = grid[y][startX];
					if (!cell.real) {
						newX = startX - (cell.colspan - 1);
						if (newX < startX && newX >= 0) {
							startX = newX;
						}
					}
				}
				// Expand startY
				for (x = startX; x <= maxX; x++) {
					cell = grid[startY][x];
					if (!cell.real) {
						newY = startY - (cell.rowspan - 1);
						if (newY < startY && newY >= 0) {
							startY = newY;
						}
					}
				}*/

					// Find max X, Y
					for (y = startY; y <= endY; y++) {
						for (x = startX; x <= endX; x++) {
							cell = grid[y][x];

							if (cell.real) {
								colSpan = cell.colspan - 1;
								rowSpan = cell.rowspan - 1;

								if (colSpan) {
									if (x + colSpan > maxX) {
										maxX = x + colSpan;
									}
								}

								if (rowSpan) {
									if (y + rowSpan > maxY) {
										maxY = y + rowSpan;
									}
								}
							}
						}
					}

					removeCellSelection();

					// Add new selection
					for (y = startY; y <= maxY; y++) {
						for (x = startX; x <= maxX; x++) {
							if (grid[y][x]) {
								dom.setAttrib(grid[y][x].elm, "data-mce-selected", "1");
							}
						}
					}
				}
			}

			function moveRelIdx(cellElm, delta) {
				let pos, index, cell;

				pos = getPos(cellElm);
				index = pos.y * gridWidth + pos.x;

				do {
					index += delta;
					cell = getCell(index % gridWidth, Math.floor(index / gridWidth));

					if (!cell) {
						break;
					}

					if (cell.elm !== cellElm) {
						selection.select(cell.elm, true);

						if (dom.isEmpty(cell.elm)) {
							selection.collapse(true);
						}

						return true;
					}
				} while (cell.elm === cellElm);

				return false;
			}

			function splitCols(before) {
				if (startPos) {
					const splitResult = SplitCols.splitAt(grid, startPos.x, startPos.y, before);
					Tools.each(splitResult.cells, fireNewCell);
				}
			}

			table = table || dom.getParent(selection.getStart(true), "table");

			buildGrid();

			selectedCell = selectedCell || dom.getParent(selection.getStart(true), "th,td");

			if (selectedCell) {
				startPos = getPos(selectedCell);
				endPos = findEndPos();
				selectedCell = getCell(startPos.x, startPos.y);
			}

			Tools.extend(this, {
				deleteTable: deleteTable,
				split: split,
				merge: merge,
				deleteCell: deleteCell,
				insertRow: insertRow,
				insertRows: insertRows,
				insertCol: insertCol,
				insertCols: insertCols,
				splitCols: splitCols,
				deleteCols: deleteCols,
				colsHeader: colsHeader,
				deleteRows: deleteRows,
				cutRows: cutRows,
				copyRows: copyRows,
				pasteRows: pasteRows,
				getPos: getPos,
				setStartCell: setStartCell,
				setEndCell: setEndCell,
				moveRelIdx: moveRelIdx,
				refresh: buildGrid,
				cleanup: cleanup,
			});
		};
	});

	// Included from: js/tinymce/plugins/table/classes/Quirks.js

	/**
	 * Quirks.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */

	/**
	 * This class includes fixes for various browser quirks.
	 * @class tinymce.tableplugin.Quirks
	 * @private
	 */
	define("tinymce/tableplugin/Quirks", [
		"tinymce/util/VK",
		"tinymce/util/Delay",
		"tinymce/Env",
		"tinymce/util/Tools",
		"tinymce/tableplugin/Utils",
	], function (VK, Delay, Env, Tools, Utils) {
		const each = Tools.each,
			getSpanVal = Utils.getSpanVal;

		return function (editor) {
			/**
			 * Fixed caret movement around tables on WebKit.
			 */
			function moveWebKitSelection() {
				function eventHandler(e) {
					const key = e.keyCode;

					function handle(upBool, sourceNode) {
						const siblingDirection = upBool ? "previousSibling" : "nextSibling";
						const currentRow = editor.dom.getParent(sourceNode, "tr");
						const siblingRow = currentRow[siblingDirection];

						if (siblingRow) {
							moveCursorToRow(editor, sourceNode, siblingRow, upBool);
							e.preventDefault();
							return true;
						}

						const tableNode = editor.dom.getParent(currentRow, "table");
						const middleNode = currentRow.parentNode;
						const parentNodeName = middleNode.nodeName.toLowerCase();
						if (parentNodeName === "tbody" || parentNodeName === (upBool ? "tfoot" : "thead")) {
							const targetParent = getTargetParent(upBool, tableNode, middleNode, "tbody");
							if (targetParent !== null) {
								return moveToRowInTarget(upBool, targetParent, sourceNode);
							}
						}

						return escapeTable(upBool, currentRow, siblingDirection, tableNode);
					}

					function getTargetParent(upBool, topNode, secondNode, nodeName) {
						const tbodies = editor.dom.select(">" + nodeName, topNode);
						const position = tbodies.indexOf(secondNode);
						if ((upBool && position === 0) || (!upBool && position === tbodies.length - 1)) {
							return getFirstHeadOrFoot(upBool, topNode);
						} else if (position === -1) {
							const topOrBottom = secondNode.tagName.toLowerCase() === "thead" ? 0 : tbodies.length - 1;
							return tbodies[topOrBottom];
						}

						return tbodies[position + (upBool ? -1 : 1)];
					}

					function getFirstHeadOrFoot(upBool, parent) {
						const tagName = upBool ? "thead" : "tfoot";
						const headOrFoot = editor.dom.select(">" + tagName, parent);
						return headOrFoot.length !== 0 ? headOrFoot[0] : null;
					}

					function moveToRowInTarget(upBool, targetParent, sourceNode) {
						const targetRow = getChildForDirection(targetParent, upBool);

						if (targetRow) {
							moveCursorToRow(editor, sourceNode, targetRow, upBool);
						}

						e.preventDefault();
						return true;
					}

					function escapeTable(upBool, currentRow, siblingDirection, table) {
						const tableSibling = table[siblingDirection];

						if (tableSibling) {
							moveCursorToStartOfElement(tableSibling);
							return true;
						}

						const parentCell = editor.dom.getParent(table, "td,th");
						if (parentCell) {
							return handle(upBool, parentCell, e);
						}

						const backUpSibling = getChildForDirection(currentRow, !upBool);
						moveCursorToStartOfElement(backUpSibling);
						e.preventDefault();
						return false;
					}

					function getChildForDirection(parent, up) {
						const child = parent && parent[up ? "lastChild" : "firstChild"];
						// BR is not a valid table child to return in this case we return the table cell
						return child && child.nodeName === "BR" ? editor.dom.getParent(child, "td,th") : child;
					}

					function moveCursorToStartOfElement(n) {
						editor.selection.setCursorLocation(n, 0);
					}

					function isVerticalMovement() {
						return key === VK.UP || key === VK.DOWN;
					}

					function isInTable(editor) {
						const node = editor.selection.getNode();
						const currentRow = editor.dom.getParent(node, "tr");
						return currentRow !== null;
					}

					function columnIndex(column) {
						let colIndex = 0;
						let c = column;
						while (c.previousSibling) {
							c = c.previousSibling;
							colIndex = colIndex + getSpanVal(c, "colspan");
						}
						return colIndex;
					}

					function findColumn(rowElement, columnIndex) {
						let c = 0,
							r = 0;

						each(rowElement.children, function (cell, i) {
							c = c + getSpanVal(cell, "colspan");
							r = i;
							if (c > columnIndex) {
								return false;
							}
						});
						return r;
					}

					function moveCursorToRow(ed, node, row, upBool) {
						const srcColumnIndex = columnIndex(editor.dom.getParent(node, "td,th"));
						const tgtColumnIndex = findColumn(row, srcColumnIndex);
						const tgtNode = row.childNodes[tgtColumnIndex];
						const rowCellTarget = getChildForDirection(tgtNode, upBool);
						moveCursorToStartOfElement(rowCellTarget || tgtNode);
					}

					function shouldFixCaret(preBrowserNode) {
						const newNode = editor.selection.getNode();
						const newParent = editor.dom.getParent(newNode, "td,th");
						const oldParent = editor.dom.getParent(preBrowserNode, "td,th");

						return newParent && newParent !== oldParent && checkSameParentTable(newParent, oldParent);
					}

					function checkSameParentTable(nodeOne, NodeTwo) {
						return editor.dom.getParent(nodeOne, "TABLE") === editor.dom.getParent(NodeTwo, "TABLE");
					}

					if (isVerticalMovement() && isInTable(editor)) {
						const preBrowserNode = editor.selection.getNode();
						Delay.setEditorTimeout(
							editor,
							function () {
								if (shouldFixCaret(preBrowserNode)) {
									handle(!e.shiftKey && key === VK.UP, preBrowserNode, e);
								}
							},
							0
						);
					}
				}

				editor.on("KeyDown", function (e) {
					eventHandler(e);
				});
			}

			function fixBeforeTableCaretBug() {
				// Checks if the selection/caret is at the start of the specified block element
				function isAtStart(rng, par) {
					let doc = par.ownerDocument,
						rng2 = doc.createRange(),
						elm;

					rng2.setStartBefore(par);
					rng2.setEnd(rng.endContainer, rng.endOffset);

					elm = doc.createElement("body");
					elm.appendChild(rng2.cloneContents());

					// Check for text characters of other elements that should be treated as content
					return (
						elm.innerHTML.replace(/<(br|img|object|embed|input|textarea)[^>]*>/gi, "-").replace(/<[^>]+>/g, "")
							.length === 0
					);
				}

				// Fixes an bug where it's impossible to place the caret before a table in Gecko
				// this fix solves it by detecting when the caret is at the beginning of such a table
				// and then manually moves the caret infront of the table
				editor.on("KeyDown", function (e) {
					let rng,
						table,
						dom = editor.dom;

					// On gecko it's not possible to place the caret before a table
					if (e.keyCode === 37 || e.keyCode === 38) {
						rng = editor.selection.getRng();
						table = dom.getParent(rng.startContainer, "table");

						if (table && editor.getBody().firstChild === table) {
							if (isAtStart(rng, table)) {
								rng = dom.createRng();

								rng.setStartBefore(table);
								rng.setEndBefore(table);

								editor.selection.setRng(rng);

								e.preventDefault();
							}
						}
					}
				});
			}

			// Fixes an issue on Gecko where it's impossible to place the caret behind a table
			// This fix will force a paragraph element after the table but only when the forced_root_block setting is enabled
			function fixTableCaretPos() {
				editor.on("KeyDown SetContent VisualAid", function () {
					let last;

					// Skip empty text nodes from the end
					for (last = editor.getBody().lastChild; last; last = last.previousSibling) {
						if (last.nodeType === 3) {
							if (last.nodeValue.length > 0) {
								break;
							}
						} else if (last.nodeType === 1 && (last.tagName === "BR" || !last.getAttribute("data-mce-bogus"))) {
							break;
						}
					}

					if (last && last.nodeName === "TABLE") {
						if (editor.settings.forced_root_block) {
							editor.dom.add(
								editor.getBody(),
								editor.settings.forced_root_block,
								editor.settings.forced_root_block_attrs,
								Env.ie && Env.ie < 10 ? "&nbsp;" : '<br data-mce-bogus="1" />'
							);
						} else {
							editor.dom.add(editor.getBody(), "br", { "data-mce-bogus": "1" });
						}
					}
				});

				editor.on("PreProcess", function (o) {
					const last = o.node.lastChild;

					if (
						last &&
						(last.nodeName === "BR" ||
							(last.childNodes.length === 1 &&
								(last.firstChild.nodeName === "BR" || last.firstChild.nodeValue === "\u00a0"))) &&
						last.previousSibling &&
						last.previousSibling.nodeName === "TABLE"
					) {
						editor.dom.remove(last);
					}
				});
			}

			// this nasty hack is here to work around some WebKit selection bugs.
			function fixTableCellSelection() {
				function tableCellSelected(ed, rng, n, currentCell) {
					// The decision of when a table cell is selected is somewhat involved.  The fact that this code is
					// required is actually a pointer to the root cause of this bug. A cell is selected when the start
					// and end offsets are 0, the start container is a text, and the selection node is either a TR (most cases)
					// or the parent of the table (in the case of the selection containing the last cell of a table).
					const TEXT_NODE = 3,
						table = ed.dom.getParent(rng.startContainer, "TABLE");
					let tableParent, allOfCellSelected, tableCellSelection;

					if (table) {
						tableParent = table.parentNode;
					}

					allOfCellSelected =
						rng.startContainer.nodeType === TEXT_NODE &&
						rng.startOffset === 0 &&
						rng.endOffset === 0 &&
						currentCell &&
						(n.nodeName === "TR" || n === tableParent);

					tableCellSelection = (n.nodeName === "TD" || n.nodeName === "TH") && !currentCell;

					return allOfCellSelected || tableCellSelection;
				}

				function fixSelection() {
					const rng = editor.selection.getRng();
					const n = editor.selection.getNode();
					let currentCell = editor.dom.getParent(rng.startContainer, "TD,TH");

					if (!tableCellSelected(editor, rng, n, currentCell)) {
						return;
					}

					if (!currentCell) {
						currentCell = n;
					}

					// Get the very last node inside the table cell
					let end = currentCell.lastChild;
					while (end.lastChild) {
						end = end.lastChild;
					}

					// Select the entire table cell. Nothing outside of the table cell should be selected.
					if (end.nodeType === 3) {
						rng.setEnd(end, end.data.length);
						editor.selection.setRng(rng);
					}
				}

				editor.on("KeyDown", function () {
					fixSelection();
				});

				editor.on("MouseDown", function (e) {
					if (e.button !== 2) {
						fixSelection();
					}
				});
			}

			/**
			 * Delete table if all cells are selected.
			 */
			function deleteTable() {
				function placeCaretInCell(cell) {
					editor.selection.select(cell, true);
					editor.selection.collapse(true);
				}

				function clearCell(cell) {
					editor.$(cell).empty();
					Utils.paddCell(cell);
				}

				editor.on("keydown", function (e) {
					if ((e.keyCode === VK.DELETE || e.keyCode === VK.BACKSPACE) && !e.isDefaultPrevented()) {
						let table, tableCells, selectedTableCells, cell;

						table = editor.dom.getParent(editor.selection.getStart(), "table");
						if (table) {
							tableCells = editor.dom.select("td,th", table);
							selectedTableCells = Tools.grep(tableCells, function (cell) {
								return !!editor.dom.getAttrib(cell, "data-mce-selected");
							});

							if (selectedTableCells.length === 0) {
								// If caret is within an empty table cell then empty it for real
								cell = editor.dom.getParent(editor.selection.getStart(), "td,th");
								if (editor.selection.isCollapsed() && cell && editor.dom.isEmpty(cell)) {
									e.preventDefault();
									clearCell(cell);
									placeCaretInCell(cell);
								}

								return;
							}

							e.preventDefault();

							editor.undoManager.transact(function () {
								if (tableCells.length === selectedTableCells.length) {
									editor.execCommand("mceTableDelete");
								} else {
									Tools.each(selectedTableCells, clearCell);
									placeCaretInCell(selectedTableCells[0]);
								}
							});
						}
					}
				});
			}

			/**
			 * When caption is empty and we continue to delete, caption gets deleted along with the contents.
			 * So, we take over delete operation (both forward and backward) and once caption is empty, we do
			 * prevent it from disappearing.
			 */
			function handleDeleteInCaption() {
				const isTableCaptionNode = function (node) {
					return node && node.nodeName === "CAPTION" && node.parentNode.nodeName === "TABLE";
				};

				const restoreCaretPlaceholder = function (node, insertCaret) {
					const rng = editor.selection.getRng();
					const caretNode = node.ownerDocument.createTextNode("\u00a0");

					// we could always append it, but caretNode somehow gets appended before caret,
					// rather then after it, effectively preventing backspace deletion
					if (rng.startOffset) {
						node.insertBefore(caretNode, node.firstChild);
					} else {
						node.appendChild(caretNode);
					}

					if (insertCaret) {
						// put the caret into the placeholder
						editor.selection.select(caretNode, true);
						editor.selection.collapse(true);
					}
				};

				const deleteBtnPressed = function (e) {
					return (e.keyCode === VK.DELETE || e.keyCode === VK.BACKSPACE) && !e.isDefaultPrevented();
				};

				const getSingleChildNode = function (node) {
					return node.firstChild === node.lastChild && node.firstChild;
				};

				const isTextNode = function (node) {
					return node && node.nodeType === 3;
				};

				const getSingleChr = function (node) {
					const childNode = getSingleChildNode(node);
					return isTextNode(childNode) && childNode.data.length === 1 ? childNode.data : null;
				};

				const hasNoCaretPlaceholder = function (node) {
					const childNode = getSingleChildNode(node);
					const chr = getSingleChr(node);
					return (childNode && !isTextNode(childNode)) || (chr && !isNBSP(chr));
				};

				const isEmptyNode = function (node) {
					return editor.dom.isEmpty(node) || isNBSP(getSingleChr(node));
				};

				var isNBSP = function (chr) {
					return chr === "\u00a0";
				};

				editor.on("keydown", function (e) {
					if (!deleteBtnPressed(e)) {
						return;
					}

					const container = editor.dom.getParent(editor.selection.getStart(), "caption");
					if (!isTableCaptionNode(container)) {
						return;
					}

					// in IE caption collapses if caret placeholder is deleted (and it is very much possible)
					if (Env.ie) {
						if (!editor.selection.isCollapsed()) {
							// if the whole contents are selected, caret placeholder will be deleted too
							// and we take over delete operation here to restore it if this happens
							editor.undoManager.transact(function () {
								editor.execCommand("Delete");

								if (isEmptyNode(container)) {
									// caret springs off from the caption (to the first td), we need to bring it back as well
									restoreCaretPlaceholder(container, true);
								}
							});

							e.preventDefault();
						} else if (hasNoCaretPlaceholder(container)) {
							// if caret placeholder got accidentally deleted and caption will collapse
							// after this operation, we need to put placeholder back
							restoreCaretPlaceholder(container);
						}
					}

					// TODO:
					// 1. in Chrome it is easily possible to select beyond the boundaries of the caption,
					// currently this results in removal of the contents with the whole caption as well;
					// 2. we could take over delete operation to address this, but then we will need to adjust
					// the selection, otherwise delete operation will remove first row of the table too;
					// 3. current behaviour is logical, so it has sense to leave it like that, until a better
					// solution

					if (isEmptyNode(container)) {
						e.preventDefault();
					}
				});
			}

			deleteTable();
			handleDeleteInCaption();

			if (Env.webkit) {
				moveWebKitSelection();
				fixTableCellSelection();
			}

			if (Env.gecko) {
				fixBeforeTableCaretBug();
				fixTableCaretPos();
			}

			if (Env.ie > 9) {
				fixBeforeTableCaretBug();
				fixTableCaretPos();
			}
		};
	});

	// Included from: js/tinymce/plugins/table/classes/CellSelection.js

	/**
	 * CellSelection.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */

	/**
	 * This class handles table cell selection by faking it using a css class that gets applied
	 * to cells when dragging the mouse from one cell to another.
	 * @class tinymce.tableplugin.CellSelection
	 * @private
	 */
	define("tinymce/tableplugin/CellSelection", [
		"tinymce/tableplugin/TableGrid",
		"tinymce/dom/TreeWalker",
		"tinymce/util/Tools",
	], function (TableGrid, TreeWalker, Tools) {
		return function (editor, selectionChange) {
			let dom = editor.dom,
				tableGrid,
				startCell,
				startTable,
				lastMouseOverTarget,
				hasCellSelection = true,
				resizing,
				dragging;

			if (!tableGrid) {
				tableGrid = new TableGrid(editor, startTable, startCell);
				tableGrid.cleanup();
			}

			function clear(force) {
				// Restore selection possibilities
				editor.getBody().style.webkitUserSelect = "";

				if (force || hasCellSelection) {
					editor.$("td[data-mce-selected],th[data-mce-selected]").removeAttr("data-mce-selected");
					hasCellSelection = false;
				}
			}

			const endSelection = function () {
				startCell = tableGrid = startTable = lastMouseOverTarget = null;
				selectionChange(false);
			};

			function isCellInTable(table, cell) {
				if (!table || !cell) {
					return false;
				}

				return table === dom.getParent(cell, "table");
			}

			function cellSelectionHandler(e) {
				let sel,
					target = e.target,
					currentCell;

				if (resizing || dragging) {
					return;
				}

				// Fake mouse enter by keeping track of last mouse over
				if (target === lastMouseOverTarget) {
					return;
				}

				lastMouseOverTarget = target;

				if (startTable && startCell) {
					currentCell = dom.getParent(target, "td,th");

					if (!isCellInTable(startTable, currentCell)) {
						currentCell = dom.getParent(startTable, "td,th");
					}

					// Selection inside first cell is normal until we have expanted
					if (startCell === currentCell && !hasCellSelection) {
						return;
					}

					selectionChange(true);

					if (isCellInTable(startTable, currentCell)) {
						e.preventDefault();

						if (!tableGrid) {
							tableGrid = new TableGrid(editor, startTable, startCell);
							editor.getBody().style.webkitUserSelect = "none";
						}

						tableGrid.setEndCell(currentCell);
						hasCellSelection = true;

						// Remove current selection
						sel = editor.selection.getSel();

						try {
							if (sel.removeAllRanges) {
								sel.removeAllRanges();
							} else {
								sel.empty();
							}
						} catch (ex) {
							// IE9 might throw errors here
						}
					}
				}
			}

			editor.on(
				"SelectionChange",
				function (e) {
					if (hasCellSelection) {
						e.stopImmediatePropagation();
					}
				},
				true
			);

			// Add cell selection logic
			editor.on("MouseDown", function (e) {
				if (e.button !== 2 && !resizing && !dragging) {
					clear();

					startCell = dom.getParent(e.target, "td,th");
					startTable = dom.getParent(startCell, "table");
				}
			});

			editor.on("mouseover", cellSelectionHandler);

			editor.on("remove", function () {
				dom.unbind(editor.getDoc(), "mouseover", cellSelectionHandler);
				clear();
			});

			editor.on("MouseUp", function () {
				let rng,
					sel = editor.selection,
					selectedCells,
					walker,
					node,
					lastNode;

				function setPoint(node, start) {
					const walker = new TreeWalker(node, node);

					do {
						// Text node
						if (node.nodeType === 3 && Tools.trim(node.nodeValue).length !== 0) {
							if (start) {
								rng.setStart(node, 0);
							} else {
								rng.setEnd(node, node.nodeValue.length);
							}

							return;
						}

						// BR element
						if (node.nodeName === "BR") {
							if (start) {
								rng.setStartBefore(node);
							} else {
								rng.setEndBefore(node);
							}

							return;
						}
					} while ((node = start ? walker.next() : walker.prev()));
				}

				// Move selection to startCell
				if (startCell) {
					if (tableGrid) {
						editor.getBody().style.webkitUserSelect = "";
					}

					// Try to expand text selection as much as we can only Gecko supports cell selection
					selectedCells = dom.select("td[data-mce-selected],th[data-mce-selected]");
					if (selectedCells.length > 0) {
						rng = dom.createRng();
						node = selectedCells[0];
						rng.setStartBefore(node);
						rng.setEndAfter(node);

						setPoint(node, 1);
						walker = new TreeWalker(node, dom.getParent(selectedCells[0], "table"));

						do {
							if (node.nodeName === "TD" || node.nodeName === "TH") {
								if (!dom.getAttrib(node, "data-mce-selected")) {
									break;
								}

								lastNode = node;
							}
						} while ((node = walker.next()));

						setPoint(lastNode);

						sel.setRng(rng);
					}

					editor.nodeChanged();
					endSelection();
				}
			});

			editor.on("KeyUp Drop SetContent", function (e) {
				clear(e.type === "setcontent");
				endSelection();
				resizing = false;
			});

			editor.on("ObjectResizeStart ObjectResized", function (e) {
				resizing = e.type !== "objectresized";
			});

			editor.on("dragstart", function () {
				dragging = true;
			});

			editor.on("drop dragend", function () {
				dragging = false;
			});

			return {
				clear: clear,
			};
		};
	});

	// Included from: js/tinymce/plugins/table/classes/Dialogs.js

	/**
	 * Dialogs.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */

	/*eslint dot-notation:0*/

	/**
	 * ...
	 * @class tinymce.tableplugin.Dialogs
	 * @private
	 */
	define("tinymce/tableplugin/Dialogs", ["tinymce/util/Tools", "tinymce/Env"], function (Tools, Env) {
		const each = Tools.each;

		return function (editor) {
			const self = this;

			function createColorPickAction() {
				const colorPickerCallback = editor.settings.color_picker_callback;

				if (colorPickerCallback) {
					return function () {
						const self = this;

						colorPickerCallback.call(
							editor,
							function (value) {
								self.value(value).fire("change");
							},
							self.value()
						);
					};
				}
			}

			function createStyleForm(dom) {
				return {
					title: "Advanced",
					type: "form",
					defaults: {
						onchange: function () {
							updateStyle(dom, this.parents().reverse()[0], this.name() === "style");
						},
					},
					items: [
						{
							label: "Style",
							name: "style",
							type: "textbox",
						},

						{
							type: "form",
							padding: 0,
							formItemDefaults: {
								layout: "grid",
								alignH: ["start", "right"],
							},
							defaults: {
								size: 7,
							},
							items: [
								{
									label: "Border color",
									type: "colorbox",
									name: "borderColor",
									onaction: createColorPickAction(),
								},

								{
									label: "Background color",
									type: "colorbox",
									name: "backgroundColor",
									onaction: createColorPickAction(),
								},
							],
						},
					],
				};
			}

			function removePxSuffix(size) {
				return size ? size.replace(/px$/, "") : "";
			}

			function addSizeSuffix(size) {
				if (/^[0-9]+$/.test(size)) {
					size += "px";
				}

				return size;
			}

			function unApplyAlign(elm) {
				each("left center right".split(" "), function (name) {
					editor.formatter.remove("align" + name, {}, elm);
				});
			}

			function unApplyVAlign(elm) {
				each("top middle bottom".split(" "), function (name) {
					editor.formatter.remove("valign" + name, {}, elm);
				});
			}

			function buildListItems(inputList, itemCallback, startItems) {
				function appendItems(values, output) {
					output = output || [];

					Tools.each(values, function (item) {
						const menuItem = { text: item.text || item.title };

						if (item.menu) {
							menuItem.menu = appendItems(item.menu);
						} else {
							menuItem.value = item.value;

							if (itemCallback) {
								itemCallback(menuItem);
							}
						}

						output.push(menuItem);
					});

					return output;
				}

				return appendItems(inputList, startItems || []);
			}

			function updateStyle(dom, win, isStyleCtrl) {
				const data = win.toJSON();
				const css = dom.parseStyle(data.style);

				if (isStyleCtrl) {
					win
						.find("#borderColor")
						.value(css["border-color"] || "")[0]
						.fire("change");
					win
						.find("#backgroundColor")
						.value(css["background-color"] || "")[0]
						.fire("change");
				} else {
					css["border-color"] = data.borderColor;
					css["background-color"] = data.backgroundColor;
				}

				win.find("#style").value(dom.serializeStyle(dom.parseStyle(dom.serializeStyle(css))));
			}

			function appendStylesToData(dom, data, elm) {
				const css = dom.parseStyle(dom.getAttrib(elm, "style"));

				if (css["border-color"]) {
					data.borderColor = css["border-color"];
				}

				if (css["background-color"]) {
					data.backgroundColor = css["background-color"];
				}

				data.style = dom.serializeStyle(css);
			}

			function mergeStyles(dom, elm, styles) {
				const css = dom.parseStyle(dom.getAttrib(elm, "style"));

				each(styles, function (style) {
					css[style.name] = style.value;
				});

				dom.setAttrib(elm, "style", dom.serializeStyle(dom.parseStyle(dom.serializeStyle(css))));
			}

			self.tableProps = function () {
				self.table(true);
			};

			self.table = function (isProps) {
				let dom = editor.dom,
					tableElm,
					colsCtrl,
					rowsCtrl,
					classListCtrl,
					data = {},
					generalTableForm,
					stylesToMerge;

				function onSubmitTableForm() {
					//Explore the layers of the table till we find the first layer of tds or ths
					function styleTDTH(elm, name, value) {
						if (elm.tagName === "TD" || elm.tagName === "TH") {
							dom.setStyle(elm, name, value);
						} else {
							if (elm.children) {
								for (let i = 0; i < elm.children.length; i++) {
									styleTDTH(elm.children[i], name, value);
								}
							}
						}
					}

					let captionElm;

					updateStyle(dom, this);
					data = Tools.extend(data, this.toJSON());

					if (data["class"] === false) {
						delete data["class"];
					}

					editor.undoManager.transact(function () {
						if (!tableElm) {
							tableElm = editor.plugins.table.insertTable(data.cols || 1, data.rows || 1);
						}

						editor.dom.setAttribs(tableElm, {
							style: data.style,
							class: data["class"],
							title: data["title"],
						});

						if (editor.settings.table_style_by_css) {
							stylesToMerge = [];
							stylesToMerge.push({ name: "border", value: data.border });
							stylesToMerge.push({ name: "border-spacing", value: addSizeSuffix(data.cellspacing) });
							mergeStyles(dom, tableElm, stylesToMerge);
							dom.setAttribs(tableElm, {
								"data-mce-border-color": data.borderColor,
								"data-mce-cell-padding": data.cellpadding,
								"data-mce-border": data.border,
							});
							if (tableElm.children) {
								for (let i = 0; i < tableElm.children.length; i++) {
									styleTDTH(tableElm.children[i], "border", data.border);
									styleTDTH(tableElm.children[i], "padding", addSizeSuffix(data.cellpadding));
								}
							}
						} else {
							editor.dom.setAttribs(tableElm, {
								border: data.border,
								cellpadding: data.cellpadding,
								cellspacing: data.cellspacing,
							});
						}

						if (dom.getAttrib(tableElm, "width") && !editor.settings.table_style_by_css) {
							dom.setAttrib(tableElm, "width", removePxSuffix(data.width));
						} else {
							dom.setStyle(tableElm, "width", addSizeSuffix(data.width));
						}

						dom.setStyle(tableElm, "height", addSizeSuffix(data.height));

						// Toggle caption on/off
						captionElm = dom.select("caption", tableElm)[0];

						if (captionElm && !data.caption) {
							dom.remove(captionElm);
						}

						if (!captionElm && data.caption) {
							captionElm = dom.create("caption");
							captionElm.innerHTML = !Env.ie ? '<br data-mce-bogus="1"/>' : "\u00a0";
							tableElm.insertBefore(captionElm, tableElm.firstChild);
						}
						unApplyAlign(tableElm);
						if (data.align) {
							editor.formatter.apply("align" + data.align, {}, tableElm);
						}

						data = window.UARM_TMCE_UTIL.tsp_getData.onSubmit(dom, data, tableElm);
						data = window.UARM_TMCE_UTIL.table2FormGetData.onSubmit(dom, data, tableElm);

						editor.focus();
						editor.addVisual();
					});
				}

				function getTDTHOverallStyle(elm, name) {
					let cells = editor.dom.select("td,th", elm),
						firstChildStyle;

					function checkChildren(firstChildStyle, elms) {
						for (let i = 0; i < elms.length; i++) {
							const currentStyle = dom.getStyle(elms[i], name);
							if (typeof firstChildStyle === "undefined") {
								firstChildStyle = currentStyle;
							}
							if (firstChildStyle !== currentStyle) {
								return "";
							}
						}

						return firstChildStyle;
					}

					firstChildStyle = checkChildren(firstChildStyle, cells);

					return firstChildStyle;
				}

				if (isProps === true) {
					tableElm = dom.getParent(editor.selection.getStart(), "table");

					if (tableElm) {
						data = {
							width: removePxSuffix(dom.getStyle(tableElm, "width") || dom.getAttrib(tableElm, "width")),
							height: removePxSuffix(dom.getStyle(tableElm, "height") || dom.getAttrib(tableElm, "height")),
							cellspacing: removePxSuffix(
								dom.getStyle(tableElm, "border-spacing") || dom.getAttrib(tableElm, "cellspacing")
							),
							cellpadding:
								dom.getAttrib(tableElm, "data-mce-cell-padding") ||
								dom.getAttrib(tableElm, "cellpadding") ||
								getTDTHOverallStyle(tableElm, "padding"),
							border:
								dom.getAttrib(tableElm, "data-mce-border") ||
								dom.getAttrib(tableElm, "border") ||
								getTDTHOverallStyle(tableElm, "border"),
							borderColor: dom.getAttrib(tableElm, "data-mce-border-color"),
							caption: !!dom.select("caption", tableElm)[0],
							class: dom.getAttrib(tableElm, "class"),
							title: dom.getAttrib(tableElm, "title"),
						};

						each("left center right".split(" "), function (name) {
							if (editor.formatter.matchNode(tableElm, "align" + name)) {
								data.align = name;
							}
						});
					}
				} else {
					colsCtrl = { label: "Cols", name: "cols" };
					rowsCtrl = { label: "Rows", name: "rows" };
				}

				if (editor.settings.table_class_list) {
					if (data["class"]) {
						data["class"] = data["class"].replace(/\s*mce\-item\-table\s*/g, "");
					}

					classListCtrl = {
						name: "class",
						type: "listbox",
						label: "Class",
						values: buildListItems(editor.settings.table_class_list, function (item) {
							if (item.value) {
								item.textStyle = function () {
									return editor.formatter.getCssText({ block: "table", classes: [item.value] });
								};
							}
						}),
					};
				}

				generalTableForm = {
					type: "form",
					layout: "flex",
					direction: "column",
					labelGapCalc: "children",
					padding: 0,
					items: [
						{
							type: "form",
							labelGapCalc: false,
							padding: 0,
							layout: "grid",
							columns: 2,
							defaults: {
								type: "textbox",
								maxWidth: 50,
							},
							items:
								editor.settings.table_appearance_options !== false
									? [
											colsCtrl,
											rowsCtrl,
											{ label: "Width", name: "width" },
											{ label: "Height", name: "height" },
											{ label: "Cell spacing", name: "cellspacing" },
											{ label: "Cell padding", name: "cellpadding" },
											{ label: "Border", name: "border" },
											{ label: "Caption", name: "caption", type: "checkbox" },
									  ]
									: [colsCtrl, rowsCtrl, { label: "Width", name: "width" }, { label: "Height", name: "height" }],
						},

						{
							label: "Alignment",
							name: "align",
							type: "listbox",
							text: "None",
							values: [
								{ text: "None", value: "" },
								{ text: "Left", value: "left" },
								{ text: "Center", value: "center" },
								{ text: "Right", value: "right" },
							],
						},

						window.UARM_TMCE_UTIL.tsp_pagiControl,
						window.UARM_TMCE_UTIL.tsp_sortControl,
						classListCtrl,
						window.UARM_TMCE_UTIL.table2FormControl,
					],
				};

				data = window.UARM_TMCE_UTIL.tsp_getData.onInit(dom, data, tableElm);
				data = window.UARM_TMCE_UTIL.table2FormGetData.onInit(dom, data, tableElm);

				if (editor.settings.table_advtab !== false) {
					appendStylesToData(dom, data, tableElm);

					editor.windowManager.open({
						title: "Table properties",
						data: data,
						bodyType: "tabpanel",
						body: [
							{
								title: "General",
								type: "form",
								items: generalTableForm,
							},
							createStyleForm(dom),
						],

						onsubmit: onSubmitTableForm,
					});
				} else {
					editor.windowManager.open({
						title: "Table properties",
						data: data,
						body: generalTableForm,
						onsubmit: onSubmitTableForm,
					});
				}
			};

			self.merge = function (grid, cell) {
				editor.windowManager.open({
					title: "Merge cells",
					body: [
						{ label: "Cols", name: "cols", type: "textbox", value: "1", size: 10 },
						{ label: "Rows", name: "rows", type: "textbox", value: "1", size: 10 },
					],
					onsubmit: function () {
						const data = this.toJSON();

						editor.undoManager.transact(function () {
							grid.merge(cell, data.cols, data.rows);
						});
					},
				});
			};

			self.cell = function () {
				let dom = editor.dom,
					cellElm,
					data,
					classListCtrl,
					cells = [];

				function setAttrib(elm, name, value) {
					if (cells.length === 1 || value) {
						dom.setAttrib(elm, name, value);
					}
				}

				function setStyle(elm, name, value) {
					if (cells.length === 1 || value) {
						dom.setStyle(elm, name, value);
					}
				}

				function onSubmitCellForm() {
					updateStyle(dom, this);
					data = Tools.extend(data, this.toJSON());

					editor.undoManager.transact(function () {
						each(cells, function (cellElm) {
							setAttrib(cellElm, "scope", data.scope);
							setAttrib(cellElm, "style", data.style);
							setAttrib(cellElm, "class", data["class"]);
							setStyle(cellElm, "width", addSizeSuffix(data.width));
							setStyle(cellElm, "height", addSizeSuffix(data.height));

							// Switch cell type
							if (data.type && cellElm.nodeName.toLowerCase() !== data.type) {
								cellElm = dom.rename(cellElm, data.type);
							}

							// Remove alignment
							if (cells.length === 1) {
								unApplyAlign(cellElm);
								unApplyVAlign(cellElm);
							}

							// Apply alignment
							if (data.align) {
								editor.formatter.apply("align" + data.align, {}, cellElm);
							}

							// Apply vertical alignment
							if (data.valign) {
								editor.formatter.apply("valign" + data.valign, {}, cellElm);
							}
						});

						editor.focus();
					});
				}

				// Get selected cells or the current cell
				cells = editor.dom.select("td[data-mce-selected],th[data-mce-selected]");
				cellElm = editor.dom.getParent(editor.selection.getStart(), "td,th");
				if (!cells.length && cellElm) {
					cells.push(cellElm);
				}

				cellElm = cellElm || cells[0];

				if (!cellElm) {
					// If this element is null, return now to avoid crashing.
					return;
				}

				if (cells.length > 1) {
					data = {
						width: "",
						height: "",
						scope: "",
						class: "",
						align: "",
						style: "",
						type: cellElm.nodeName.toLowerCase(),
					};
				} else {
					data = {
						width: removePxSuffix(dom.getStyle(cellElm, "width") || dom.getAttrib(cellElm, "width")),
						height: removePxSuffix(dom.getStyle(cellElm, "height") || dom.getAttrib(cellElm, "height")),
						scope: dom.getAttrib(cellElm, "scope"),
						class: dom.getAttrib(cellElm, "class"),
					};

					data.type = cellElm.nodeName.toLowerCase();

					each("left center right".split(" "), function (name) {
						if (editor.formatter.matchNode(cellElm, "align" + name)) {
							data.align = name;
						}
					});

					each("top middle bottom".split(" "), function (name) {
						if (editor.formatter.matchNode(cellElm, "valign" + name)) {
							data.valign = name;
						}
					});

					appendStylesToData(dom, data, cellElm);
				}

				if (editor.settings.table_cell_class_list) {
					classListCtrl = {
						name: "class",
						type: "listbox",
						label: "Class",
						values: buildListItems(editor.settings.table_cell_class_list, function (item) {
							if (item.value) {
								item.textStyle = function () {
									return editor.formatter.getCssText({ block: "td", classes: [item.value] });
								};
							}
						}),
					};
				}

				const generalCellForm = {
					type: "form",
					layout: "flex",
					direction: "column",
					labelGapCalc: "children",
					padding: 0,
					items: [
						{
							type: "form",
							layout: "grid",
							columns: 2,
							labelGapCalc: false,
							padding: 0,
							defaults: {
								type: "textbox",
								maxWidth: 50,
							},
							items: [
								{ label: "Width", name: "width" },
								{ label: "Height", name: "height" },
								{
									label: "Cell type",
									name: "type",
									type: "listbox",
									text: "None",
									minWidth: 90,
									maxWidth: null,
									values: [
										{ text: "Cell", value: "td" },
										{ text: "Header cell", value: "th" },
									],
								},
								{
									label: "Scope",
									name: "scope",
									type: "listbox",
									text: "None",
									minWidth: 90,
									maxWidth: null,
									values: [
										{ text: "None", value: "" },
										{ text: "Row", value: "row" },
										{ text: "Column", value: "col" },
										{ text: "Row group", value: "rowgroup" },
										{ text: "Column group", value: "colgroup" },
									],
								},
								{
									label: "H Align",
									name: "align",
									type: "listbox",
									text: "None",
									minWidth: 90,
									maxWidth: null,
									values: [
										{ text: "None", value: "" },
										{ text: "Left", value: "left" },
										{ text: "Center", value: "center" },
										{ text: "Right", value: "right" },
									],
								},
								{
									label: "V Align",
									name: "valign",
									type: "listbox",
									text: "None",
									minWidth: 90,
									maxWidth: null,
									values: [
										{ text: "None", value: "" },
										{ text: "Top", value: "top" },
										{ text: "Middle", value: "middle" },
										{ text: "Bottom", value: "bottom" },
									],
								},
							],
						},

						classListCtrl,
					],
				};

				if (editor.settings.table_cell_advtab !== false) {
					editor.windowManager.open({
						title: "Cell properties",
						bodyType: "tabpanel",
						data: data,
						body: [
							{
								title: "General",
								type: "form",
								items: generalCellForm,
							},

							createStyleForm(dom),
						],

						onsubmit: onSubmitCellForm,
					});
				} else {
					editor.windowManager.open({
						title: "Cell properties",
						data: data,
						body: generalCellForm,
						onsubmit: onSubmitCellForm,
					});
				}
			};

			self.row = function () {
				let dom = editor.dom,
					tableElm,
					cellElm,
					rowElm,
					classListCtrl,
					data,
					rows = [],
					generalRowForm;

				function setAttrib(elm, name, value) {
					if (rows.length === 1 || value) {
						dom.setAttrib(elm, name, value);
					}
				}

				function setStyle(elm, name, value) {
					if (rows.length === 1 || value) {
						dom.setStyle(elm, name, value);
					}
				}

				function toggleRowTdTh(elm) {
					elm.childNodes.forEach(function (item) {
						let newTag;
						let index;
						if (item.tagName === "TD") {
							newTag = dom.create("th");
							item.setAttribute("scope", "col");
						} else if (item.getAttribute("scope") !== "row") {
							newTag = dom.create("td");
							item.removeAttribute("scope");
						} else if (item.getAttribute("data-vHead") === "vHead") {
							item.setAttribute("scope", "row");
						} else {
							item.setAttribute("scope", "col");
						}
						if (newTag) {
							while (item.firstChild) {
								newTag.appendChild(item.firstChild); // *Moves* the child
							}
							// Copy the attributes
							for (index = item.attributes.length - 1; index >= 0; --index) {
								newTag.attributes.setNamedItem(item.attributes[index].cloneNode());
							}
							// Insert it
							elm.replaceChild(newTag, item);
						}
					});
				}

				function onSubmitRowForm() {
					let tableElm, oldParentElm, parentElm;
					updateStyle(dom, this);
					data = Tools.extend(data, this.toJSON());

					editor.undoManager.transact(function () {
						const toType = data.type;

						each(rows, function (rowElm) {
							setAttrib(rowElm, "scope", data.scope);
							setAttrib(rowElm, "style", data.style);
							setAttrib(rowElm, "class", data["class"]);
							setStyle(rowElm, "height", addSizeSuffix(data.height));

							if (toType !== rowElm.parentNode.nodeName.toLowerCase()) {
								tableElm = dom.getParent(rowElm, "table");

								oldParentElm = rowElm.parentNode;
								parentElm = dom.select(toType, tableElm)[0];

								if (!parentElm) {
									parentElm = dom.create(toType);
									if (tableElm.firstChild) {
										if (
											(tableElm.firstChild.tagName === "CAPTION" && parentElm.tagName === "THEAD") ||
											tableElm.firstChild.tagName === "THEAD" ||
											(tableElm.firstChild.tagName === "CAPTION" &&
												tableElm.children[1].tagName !== "THEAD" &&
												parentElm.tagName === "TFOOT")
										) {
											tableElm.insertBefore(parentElm, tableElm.firstChild.nextSibling);
										} else if (tableElm.firstChild.tagName === "CAPTION" && tableElm.children[1].tagName === "THEAD") {
											tableElm.insertBefore(parentElm, tableElm.children[1].nextSibling);
										} else {
											tableElm.insertBefore(parentElm, tableElm.firstChild);
										}
									} else {
										tableElm.appendChild(parentElm);
									}
								}

								if (parentElm.tagName === "THEAD") {
									toggleRowTdTh(rowElm);
								}
								if (oldParentElm.tagName === "THEAD") {
									toggleRowTdTh(rowElm);
								}

								if (oldParentElm.tagName === "THEAD" && parentElm.tagName === "TBODY") {
									parentElm.insertBefore(rowElm, parentElm.firstChild);
								} else {
									parentElm.appendChild(rowElm);
								}

								if (!oldParentElm.hasChildNodes()) {
									dom.remove(oldParentElm);
								}
							}

							// Apply/remove alignment
							if (rows.length === 1) {
								unApplyAlign(rowElm);
							}

							if (data.align) {
								editor.formatter.apply("align" + data.align, {}, rowElm);
							}
						});

						data = window.UARM_TMCE_UTIL.table2RowGetData.onSubmit(dom, data, rowElm);

						editor.focus();
					});
				}

				tableElm = editor.dom.getParent(editor.selection.getStart(), "table");
				cellElm = editor.dom.getParent(editor.selection.getStart(), "td,th");

				each(tableElm.rows, function (row) {
					each(row.cells, function (cell) {
						if (dom.getAttrib(cell, "data-mce-selected") || cell === cellElm) {
							rows.push(row);
							return false;
						}
					});
				});

				rowElm = rows[0];
				if (!rowElm) {
					// If this element is null, return now to avoid crashing.
					return;
				}

				if (rows.length > 1) {
					data = {
						height: "",
						scope: "",
						class: "",
						align: "",
						type: rowElm.parentNode.nodeName.toLowerCase(),
					};
				} else {
					data = {
						height: removePxSuffix(dom.getStyle(rowElm, "height") || dom.getAttrib(rowElm, "height")),
						scope: dom.getAttrib(rowElm, "scope"),
						class: dom.getAttrib(rowElm, "class"),
					};

					data.type = rowElm.parentNode.nodeName.toLowerCase();

					each("left center right".split(" "), function (name) {
						if (editor.formatter.matchNode(rowElm, "align" + name)) {
							data.align = name;
						}
					});

					appendStylesToData(dom, data, rowElm);
				}

				if (editor.settings.table_row_class_list) {
					classListCtrl = {
						name: "class",
						type: "listbox",
						label: "Class",
						values: buildListItems(editor.settings.table_row_class_list, function (item) {
							if (item.value) {
								item.textStyle = function () {
									return editor.formatter.getCssText({ block: "tr", classes: [item.value] });
								};
							}
						}),
					};
				}

				generalRowForm = {
					type: "form",
					layout: "flex",
					direction: "column",
					labelGapCalc: "children",
					defaults: {
						type: "textbox",
					},
					items: [
						{
							type: "listbox",
							name: "type",
							label: "Row type",
							text: "Header",
							maxWidth: null,
							values: [
								{ text: "Header", value: "thead" },
								{ text: "Body", value: "tbody" },
								{ text: "Footer", value: "tfoot" },
							],
						},
						{
							type: "listbox",
							name: "align",
							label: "Alignment",
							text: "None",
							maxWidth: null,
							values: [
								{ text: "None", value: "" },
								{ text: "Left", value: "left" },
								{ text: "Center", value: "center" },
								{ text: "Right", value: "right" },
							],
						},
						{ label: "Height", name: "height" },

						window.UARM_TMCE_UTIL.table2RowControl,

						classListCtrl,
					],
				};

				data = window.UARM_TMCE_UTIL.table2RowGetData.onInit(dom, data, rowElm);

				if (editor.settings.table_row_advtab !== false) {
					editor.windowManager.open({
						title: "Row properties",
						data: data,
						bodyType: "tabpanel",
						body: [
							{
								title: "General",
								type: "form",
								items: generalRowForm,
							},
							createStyleForm(dom),
						],

						onsubmit: onSubmitRowForm,
					});
				} else {
					editor.windowManager.open({
						title: "Row properties",
						data: data,
						body: generalRowForm,
						onsubmit: onSubmitRowForm,
					});
				}
			};

			self.col = function () {
				let dom = editor.dom,
					tableElm,
					cellElm,
					colElm,
					colIndex,
					classListCtrl,
					data,
					cols = [],
					generalColForm;

				function setAttrib(elm, name, value) {
					if (value) {
						dom.setAttrib(elm, name, value);
					}
				}
				function toggleColTdTh(cols) {
					let newTag;
					each(cols, function (colElm) {
						if (colElm.tagName === "TD") {
							newTag = dom.create("th");
							newTag.setAttribute("scope", "row");
						} else {
							if (colElm.getAttribute("scope") === "row") {
								newTag = dom.create("td");
							}
						}
						if (newTag) {
							while (colElm.firstChild) {
								newTag.appendChild(colElm.firstChild); // *Moves* the child
							}
							setAttrib(newTag, "class", data["table2__col_dark"]);
							setAttrib(newTag, "data-vHead", data["vHead"]);
							// Insert it
							colElm.parentNode.replaceChild(newTag, colElm);
						}
					});
				}

				function onSubmitColForm() {
					let tableElm, oldParentElm, parentElm;

					updateStyle(dom, this);
					data = Tools.extend(data, this.toJSON());

					editor.undoManager.transact(function () {
						toggleColTdTh(cols);

						data = window.UARM_TMCE_UTIL.table2ColGetData.onSubmit(dom, data, colElm);

						editor.focus();
					});
				}

				tableElm = editor.dom.getParent(editor.selection.getStart(), "table");
				cellElm = editor.dom.getParent(editor.selection.getStart(), "td,th");
				colIndex = cellElm.cellIndex;

				each(tableElm.rows, function (row) {
					cols.push(row.cells[colIndex]);
				});

				colElm = cols;
				if (!colElm) {
					// If this element is null, return now to avoid crashing.
					return;
				}

				if (cols) {
					data = {
						"class": dom.getAttrib(colElm, "class"),
						"data-vHead": dom.getAttrib(colElm, "data-vHead"),
					};
				}

				generalColForm = {
					type: "form",
					layout: "flex",
					direction: "column",
					labelGapCalc: "children",
					defaults: {
						type: "textbox",
					},
					items: [window.UARM_TMCE_UTIL.table2ColControl, classListCtrl],
				};

				data = window.UARM_TMCE_UTIL.table2ColGetData.onInit(dom, data, colElm);

				if (editor.settings.table_row_advtab !== false) {
					editor.windowManager.open({
						title: "Col properties",
						data: data,
						bodyType: "tabpanel",
						body: [
							{
								title: "General",
								type: "form",
								items: generalColForm,
							},
							createStyleForm(dom),
						],

						onsubmit: onSubmitColForm,
					});
				} else {
					editor.windowManager.open({
						title: "Col properties",
						data: data,
						body: generalColForm,
						onsubmit: onSubmitColForm,
					});
				}
			};
		};
	});

	// Included from: js/tinymce/plugins/table/classes/ResizeBars.js

	/**
	 * ResizeBars.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */

	/**
	 * This class handles table column and row resizing by adding divs over the columns and rows of the table.
	 * These divs are then manipulated using mouse events to resize the underlying table.
	 * @class tinymce.tableplugin.ResizeBars
	 * @private
	 */
	define("tinymce/tableplugin/ResizeBars", ["tinymce/util/Tools", "tinymce/util/VK"], function (Tools, VK) {
		let hoverTable;

		return function (editor) {
			const RESIZE_BAR_CLASS = "mce-resize-bar",
				RESIZE_BAR_ROW_CLASS = "mce-resize-bar-row",
				RESIZE_BAR_ROW_CURSOR_STYLE = "row-resize",
				RESIZE_BAR_ROW_DATA_ATTRIBUTE = "data-row",
				RESIZE_BAR_ROW_DATA_INITIAL_TOP_ATTRIBUTE = "data-initial-top",
				RESIZE_BAR_COL_CLASS = "mce-resize-bar-col",
				RESIZE_BAR_COL_CURSOR_STYLE = "col-resize",
				RESIZE_BAR_COL_DATA_ATTRIBUTE = "data-col",
				RESIZE_BAR_COL_DATA_INITIAL_LEFT_ATTRIBUTE = "data-initial-left",
				RESIZE_BAR_THICKNESS = 4,
				RESIZE_MINIMUM_WIDTH = 10,
				RESIZE_MINIMUM_HEIGHT = 10,
				RESIZE_BAR_DRAGGING_CLASS = "mce-resize-bar-dragging";

			const percentageBasedSizeRegex = new RegExp(/(\d+(\.\d+)?%)/),
				pixelBasedSizeRegex = new RegExp(/px|em/);

			let delayDrop, dragging, blockerElement, dragBar, lastX, lastY;

			// Get the absolute position's top edge.
			function getTopEdge(index, row) {
				return {
					index: index,
					y: editor.dom.getPos(row).y,
				};
			}

			// Get the absolute position's bottom edge.
			function getBottomEdge(index, row) {
				return {
					index: index,
					y: editor.dom.getPos(row).y + row.offsetHeight,
				};
			}

			// Get the absolute position's left edge.
			function getLeftEdge(index, cell) {
				return {
					index: index,
					x: editor.dom.getPos(cell).x,
				};
			}

			// Get the absolute position's right edge.
			function getRightEdge(index, cell) {
				return {
					index: index,
					x: editor.dom.getPos(cell).x + cell.offsetWidth,
				};
			}

			function isRtl() {
				const dir = editor.getBody().dir;
				return dir === "rtl";
			}

			function isInline() {
				return editor.inline;
			}

			function getBody() {
				return isInline ? editor.getBody().ownerDocument.body : editor.getBody();
			}

			function getInnerEdge(index, cell) {
				return isRtl() ? getRightEdge(index, cell) : getLeftEdge(index, cell);
			}

			function getOuterEdge(index, cell) {
				return isRtl() ? getLeftEdge(index, cell) : getRightEdge(index, cell);
			}

			function getPercentageWidthFallback(element, table) {
				return (getComputedStyleSize(element, "width") / getComputedStyleSize(table, "width")) * 100;
			}

			function getComputedStyleSize(element, property) {
				const widthString = editor.dom.getStyle(element, property, true);
				const width = parseInt(widthString, 10);
				return width;
			}

			function getCurrentTablePercentWidth(table) {
				const tableWidth = getComputedStyleSize(table, "width");
				const tableParentWidth = getComputedStyleSize(table.parentElement, "width");
				return (tableWidth / tableParentWidth) * 100;
			}

			function getCellPercentDelta(table, delta) {
				const tableWidth = getComputedStyleSize(table, "width");
				return (delta / tableWidth) * 100;
			}

			function getTablePercentDelta(table, delta) {
				const tableParentWidth = getComputedStyleSize(table.parentElement, "width");
				return (delta / tableParentWidth) * 100;
			}

			// Find the left/right (ltr/rtl) or top side locations of the cells to measure.
			// This is the location of the borders we need to draw over.
			function findPositions(getInner, getOuter, thingsToMeasure) {
				const tablePositions = [];

				// Skip the first item in the array = no left (LTR), right (RTL) or top bars
				for (let i = 1; i < thingsToMeasure.length; i++) {
					// Get the element from the details
					const item = thingsToMeasure[i].element;

					// We need to zero index this again
					tablePositions.push(getInner(i - 1, item));
				}

				const lastTableLineToMake = thingsToMeasure[thingsToMeasure.length - 1];
				tablePositions.push(getOuter(thingsToMeasure.length - 1, lastTableLineToMake.element));

				return tablePositions;
			}

			// Clear the bars.
			function clearBars() {
				const bars = editor.dom.select("." + RESIZE_BAR_CLASS, getBody());
				Tools.each(bars, function (bar) {
					editor.dom.remove(bar);
				});
			}

			// Refresh the bars.
			function refreshBars(tableElement) {
				clearBars();
				drawBars(tableElement);
			}

			// Generates a resize bar object for the editor to add.
			function generateBar(classToAdd, cursor, left, top, height, width, indexAttr, index) {
				const bar = {
					"data-mce-bogus": "all",
					"class": RESIZE_BAR_CLASS + " " + classToAdd,
					"unselectable": "on",
					"data-mce-resize": false,
					"style":
						"cursor: " +
						cursor +
						"; " +
						"margin: 0; " +
						"padding: 0; " +
						"position: absolute; " +
						"left: " +
						left +
						"px; " +
						"top: " +
						top +
						"px; " +
						"height: " +
						height +
						"px; " +
						"width: " +
						width +
						"px; ",
				};

				bar[indexAttr] = index;

				return bar;
			}

			// Draw the row bars over the row borders.
			function drawRows(rowPositions, tableWidth, tablePosition) {
				Tools.each(rowPositions, function (rowPosition) {
					const left = tablePosition.x,
						top = rowPosition.y - RESIZE_BAR_THICKNESS / 2,
						height = RESIZE_BAR_THICKNESS,
						width = tableWidth;

					editor.dom.add(
						getBody(),
						"div",
						generateBar(
							RESIZE_BAR_ROW_CLASS,
							RESIZE_BAR_ROW_CURSOR_STYLE,
							left,
							top,
							height,
							width,
							RESIZE_BAR_ROW_DATA_ATTRIBUTE,
							rowPosition.index
						)
					);
				});
			}

			// Draw the column bars over the column borders.
			function drawCols(cellPositions, tableHeight, tablePosition) {
				Tools.each(cellPositions, function (cellPosition) {
					const left = cellPosition.x - RESIZE_BAR_THICKNESS / 2,
						top = tablePosition.y,
						height = tableHeight,
						width = RESIZE_BAR_THICKNESS;

					editor.dom.add(
						getBody(),
						"div",
						generateBar(
							RESIZE_BAR_COL_CLASS,
							RESIZE_BAR_COL_CURSOR_STYLE,
							left,
							top,
							height,
							width,
							RESIZE_BAR_COL_DATA_ATTRIBUTE,
							cellPosition.index
						)
					);
				});
			}

			// Get a matrix of the cells in each row and the rows in the table.
			function getTableDetails(table) {
				return Tools.map(table.rows, function (row) {
					const cells = Tools.map(row.cells, function (cell) {
						const rowspan = cell.hasAttribute("rowspan") ? parseInt(cell.getAttribute("rowspan"), 10) : 1;
						const colspan = cell.hasAttribute("colspan") ? parseInt(cell.getAttribute("colspan"), 10) : 1;

						return {
							element: cell,
							rowspan: rowspan,
							colspan: colspan,
						};
					});

					return {
						element: row,
						cells: cells,
					};
				});
			}

			// Get a grid model of the table.
			function getTableGrid(tableDetails) {
				function key(rowIndex, colIndex) {
					return rowIndex + "," + colIndex;
				}

				function getAt(rowIndex, colIndex) {
					return access[key(rowIndex, colIndex)];
				}

				function getAllCells() {
					let allCells = [];
					Tools.each(rows, function (row) {
						allCells = allCells.concat(row.cells);
					});
					return allCells;
				}

				function getAllRows() {
					return rows;
				}

				var access = {};
				var rows = [];

				let maxRows = 0;
				let maxCols = 0;

				Tools.each(tableDetails, function (row, rowIndex) {
					const currentRow = [];

					Tools.each(row.cells, function (cell) {
						let start = 0;

						while (access[key(rowIndex, start)] !== undefined) {
							start++;
						}

						const current = {
							element: cell.element,
							colspan: cell.colspan,
							rowspan: cell.rowspan,
							rowIndex: rowIndex,
							colIndex: start,
						};

						for (let i = 0; i < cell.colspan; i++) {
							for (let j = 0; j < cell.rowspan; j++) {
								const cr = rowIndex + j;
								const cc = start + i;
								access[key(cr, cc)] = current;
								maxRows = Math.max(maxRows, cr + 1);
								maxCols = Math.max(maxCols, cc + 1);
							}
						}

						currentRow.push(current);
					});

					rows.push({
						element: row.element,
						cells: currentRow,
					});
				});

				return {
					grid: {
						maxRows: maxRows,
						maxCols: maxCols,
					},
					getAt: getAt,
					getAllCells: getAllCells,
					getAllRows: getAllRows,
				};
			}

			function range(start, end) {
				const r = [];

				for (let i = start; i < end; i++) {
					r.push(i);
				}

				return r;
			}

			// Attempt to get a representative single block for this column.
			// If we can't find a single block, all blocks in this row/column are spanned
			// and we'll need to fallback to getting the first cell in the row/column.
			function decide(getBlock, isSingle, getFallback) {
				const inBlock = getBlock();
				let singleInBlock;

				for (let i = 0; i < inBlock.length; i++) {
					if (isSingle(inBlock[i])) {
						singleInBlock = inBlock[i];
					}
				}
				return singleInBlock ? singleInBlock : getFallback();
			}

			// Attempt to get representative blocks for the width of each column.
			function getColumnBlocks(tableGrid) {
				const cols = range(0, tableGrid.grid.maxCols);
				const rows = range(0, tableGrid.grid.maxRows);

				return Tools.map(cols, function (col) {
					function getBlock() {
						const details = [];
						for (let i = 0; i < rows.length; i++) {
							const detail = tableGrid.getAt(i, col);
							if (detail && detail.colIndex === col) {
								details.push(detail);
							}
						}

						return details;
					}

					function isSingle(detail) {
						return detail.colspan === 1;
					}

					function getFallback() {
						let item;

						for (let i = 0; i < rows.length; i++) {
							item = tableGrid.getAt(i, col);
							if (item) {
								return item;
							}
						}

						return null;
					}

					return decide(getBlock, isSingle, getFallback);
				});
			}

			// Attempt to get representative blocks for the height of each row.
			function getRowBlocks(tableGrid) {
				const cols = range(0, tableGrid.grid.maxCols);
				const rows = range(0, tableGrid.grid.maxRows);

				return Tools.map(rows, function (row) {
					function getBlock() {
						const details = [];
						for (let i = 0; i < cols.length; i++) {
							const detail = tableGrid.getAt(row, i);
							if (detail && detail.rowIndex === row) {
								details.push(detail);
							}
						}
						return details;
					}

					function isSingle(detail) {
						return detail.rowspan === 1;
					}

					function getFallback() {
						return tableGrid.getAt(row, 0);
					}

					return decide(getBlock, isSingle, getFallback);
				});
			}

			// Draw resize bars over the left/right (ltr/rtl) or top side locations of the cells to measure.
			// This is the location of the borders we need to draw over.
			function drawBars(table) {
				const tableDetails = getTableDetails(table);
				const tableGrid = getTableGrid(tableDetails);
				const rows = getRowBlocks(tableGrid);
				const cols = getColumnBlocks(tableGrid);

				const tablePosition = editor.dom.getPos(table);
				const rowPositions = rows.length > 0 ? findPositions(getTopEdge, getBottomEdge, rows) : [];
				const colPositions = cols.length > 0 ? findPositions(getInnerEdge, getOuterEdge, cols) : [];

				drawRows(rowPositions, table.offsetWidth, tablePosition);
				drawCols(colPositions, table.offsetHeight, tablePosition);
			}

			// Attempt to deduce the width/height of a column/row that has more than one cell spanned.
			function deduceSize(deducables, index, isPercentageBased, table) {
				if (index < 0 || index >= deducables.length - 1) {
					return "";
				}

				let current = deducables[index];

				if (current) {
					current = {
						value: current,
						delta: 0,
					};
				} else {
					const reversedUpToIndex = deducables.slice(0, index).reverse();
					for (let i = 0; i < reversedUpToIndex.length; i++) {
						if (reversedUpToIndex[i]) {
							current = {
								value: reversedUpToIndex[i],
								delta: i + 1,
							};
						}
					}
				}

				let next = deducables[index + 1];

				if (next) {
					next = {
						value: next,
						delta: 1,
					};
				} else {
					const rest = deducables.slice(index + 1);
					for (let j = 0; j < rest.length; j++) {
						if (rest[j]) {
							next = {
								value: rest[j],
								delta: j + 1,
							};
						}
					}
				}

				const extras = next.delta - current.delta;
				const pixelWidth = Math.abs(next.value - current.value) / extras;
				return isPercentageBased ? (pixelWidth / getComputedStyleSize(table, "width")) * 100 : pixelWidth;
			}

			function getStyleOrAttrib(element, property) {
				let sizeString = editor.dom.getStyle(element, property);
				if (!sizeString) {
					sizeString = editor.dom.getAttrib(element, property);
				}
				if (!sizeString) {
					sizeString = editor.dom.getStyle(element, property, true);
				}
				return sizeString;
			}

			function getWidth(element, isPercentageBased, table) {
				const widthString = getStyleOrAttrib(element, "width");

				let widthNumber = parseInt(widthString, 10);

				const getWidthFallback = isPercentageBased
					? getPercentageWidthFallback(element, table)
					: getComputedStyleSize(element, "width");

				// If this is percentage based table, but this cell isn't percentage based.
				// Or if this is a pixel based table, but this cell isn't pixel based.
				if (
					(isPercentageBased && !isPercentageBasedSize(widthString)) ||
					(!isPercentageBased && !isPixelBasedSize(widthString))
				) {
					// set the widthnumber to 0
					widthNumber = 0;
				}

				return !isNaN(widthNumber) && widthNumber > 0 ? widthNumber : getWidthFallback;
			}

			// Attempt to get the css width from column representative cells.
			function getWidths(tableGrid, isPercentageBased, table) {
				const cols = getColumnBlocks(tableGrid);

				const backups = Tools.map(cols, function (col) {
					return getInnerEdge(col.colIndex, col.element).x;
				});

				const widths = [];

				for (let i = 0; i < cols.length; i++) {
					const span = cols[i].element.hasAttribute("colspan")
						? parseInt(cols[i].element.getAttribute("colspan"), 10)
						: 1;
					// Deduce if the column has colspan of more than 1
					let width = span > 1 ? deduceSize(backups, i) : getWidth(cols[i].element, isPercentageBased, table);
					// If everything's failed and we still don't have a width
					width = width ? width : RESIZE_MINIMUM_WIDTH;
					widths.push(width);
				}

				return widths;
			}

			// Attempt to get the pixel height from a cell.
			function getPixelHeight(element) {
				const heightString = getStyleOrAttrib(element, "height");

				let heightNumber = parseInt(heightString, 10);

				if (isPercentageBasedSize(heightString)) {
					heightNumber = 0;
				}

				return !isNaN(heightNumber) && heightNumber > 0 ? heightNumber : getComputedStyleSize(element, "height");
			}

			// Attempt to get the css height from row representative cells.
			function getPixelHeights(tableGrid) {
				const rows = getRowBlocks(tableGrid);

				const backups = Tools.map(rows, function (row) {
					return getTopEdge(row.rowIndex, row.element).y;
				});

				const heights = [];

				for (let i = 0; i < rows.length; i++) {
					const span = rows[i].element.hasAttribute("rowspan")
						? parseInt(rows[i].element.getAttribute("rowspan"), 10)
						: 1;

					let height = span > 1 ? deduceSize(backups, i) : getPixelHeight(rows[i].element);

					height = height ? height : RESIZE_MINIMUM_HEIGHT;
					heights.push(height);
				}

				return heights;
			}

			// Determine how much each column's css width will need to change.
			// Sizes = result = pixels widths OR percentage based widths
			function determineDeltas(sizes, column, step, min, isPercentageBased) {
				const result = sizes.slice(0);

				function generateZeros(array) {
					return Tools.map(array, function () {
						return 0;
					});
				}

				function onOneColumn() {
					let deltas;
					if (isPercentageBased) {
						// If we have one column in a percent based table, that column should be 100% of the width of the table.
						deltas = [100 - result[0]];
					} else {
						const newNext = Math.max(min, result[0] + step);
						deltas = [newNext - result[0]];
					}
					return deltas;
				}

				function onLeftOrMiddle(index, next) {
					const startZeros = generateZeros(result.slice(0, index));
					const endZeros = generateZeros(result.slice(next + 1));
					let deltas;

					if (step >= 0) {
						const newNext = Math.max(min, result[next] - step);
						deltas = startZeros.concat([step, newNext - result[next]]).concat(endZeros);
					} else {
						const newThis = Math.max(min, result[index] + step);
						const diffx = result[index] - newThis;
						deltas = startZeros.concat([newThis - result[index], diffx]).concat(endZeros);
					}

					return deltas;
				}

				function onRight(previous, index) {
					const startZeros = generateZeros(result.slice(0, index));
					let deltas;

					if (step >= 0) {
						deltas = startZeros.concat([step]);
					} else {
						const size = Math.max(min, result[index] + step);
						deltas = startZeros.concat([size - result[index]]);
					}

					return deltas;
				}

				let deltas;

				if (sizes.length === 0) {
					// No Columns
					deltas = [];
				} else if (sizes.length === 1) {
					// One Column
					deltas = onOneColumn();
				} else if (column === 0) {
					// Left Column
					deltas = onLeftOrMiddle(0, 1);
				} else if (column > 0 && column < sizes.length - 1) {
					// Middle Column
					deltas = onLeftOrMiddle(column, column + 1);
				} else if (column === sizes.length - 1) {
					// Right Column
					deltas = onRight(column - 1, column);
				} else {
					deltas = [];
				}

				return deltas;
			}

			function total(start, end, measures) {
				let r = 0;
				for (let i = start; i < end; i++) {
					r += measures[i];
				}
				return r;
			}

			// Combine cell's css widths to determine widths of colspan'd cells.
			function recalculateWidths(tableGrid, widths) {
				const allCells = tableGrid.getAllCells();
				return Tools.map(allCells, function (cell) {
					const width = total(cell.colIndex, cell.colIndex + cell.colspan, widths);
					return {
						element: cell.element,
						width: width,
						colspan: cell.colspan,
					};
				});
			}

			// Combine cell's css heights to determine heights of rowspan'd cells.
			function recalculateCellHeights(tableGrid, heights) {
				const allCells = tableGrid.getAllCells();
				return Tools.map(allCells, function (cell) {
					const height = total(cell.rowIndex, cell.rowIndex + cell.rowspan, heights);
					return {
						element: cell.element,
						height: height,
						rowspan: cell.rowspan,
					};
				});
			}

			// Calculate row heights.
			function recalculateRowHeights(tableGrid, heights) {
				const allRows = tableGrid.getAllRows();
				return Tools.map(allRows, function (row, i) {
					return {
						element: row.element,
						height: heights[i],
					};
				});
			}

			function isPercentageBasedSize(size) {
				return percentageBasedSizeRegex.test(size);
			}

			function isPixelBasedSize(size) {
				return pixelBasedSizeRegex.test(size);
			}

			// Adjust the width of the column of table at index, with delta.
			function adjustWidth(table, delta, index) {
				const tableDetails = getTableDetails(table);
				const tableGrid = getTableGrid(tableDetails);

				function setSizes(newSizes, styleExtension) {
					Tools.each(newSizes, function (cell) {
						editor.dom.setStyle(cell.element, "width", cell.width + styleExtension);
						editor.dom.setAttrib(cell.element, "width", null);
					});
				}

				function getNewTablePercentWidth() {
					return index < tableGrid.grid.maxCols - 1
						? getCurrentTablePercentWidth(table)
						: getCurrentTablePercentWidth(table) + getTablePercentDelta(table, delta);
				}

				function getNewTablePixelWidth() {
					return index < tableGrid.grid.maxCols - 1
						? getComputedStyleSize(table, "width")
						: getComputedStyleSize(table, "width") + delta;
				}

				function setTableSize(newTableWidth, styleExtension, isPercentBased) {
					if (index === tableGrid.grid.maxCols - 1 || !isPercentBased) {
						editor.dom.setStyle(table, "width", newTableWidth + styleExtension);
						editor.dom.setAttrib(table, "width", null);
					}
				}

				const percentageBased = isPercentageBasedSize(table.width) || isPercentageBasedSize(table.style.width);

				const widths = getWidths(tableGrid, percentageBased, table);

				const step = percentageBased ? getCellPercentDelta(table, delta) : delta;
				// TODO: change the min for percentage maybe?
				const deltas = determineDeltas(widths, index, step, RESIZE_MINIMUM_WIDTH, percentageBased, table);
				const newWidths = [];

				for (let i = 0; i < deltas.length; i++) {
					newWidths.push(deltas[i] + widths[i]);
				}

				const newSizes = recalculateWidths(tableGrid, newWidths);
				const styleExtension = percentageBased ? "%" : "px";
				const newTableWidth = percentageBased ? getNewTablePercentWidth() : getNewTablePixelWidth();

				editor.undoManager.transact(function () {
					setSizes(newSizes, styleExtension);
					setTableSize(newTableWidth, styleExtension, percentageBased);
				});
			}

			// Adjust the height of the row of table at index, with delta.
			function adjustHeight(table, delta, index) {
				const tableDetails = getTableDetails(table);
				const tableGrid = getTableGrid(tableDetails);

				const heights = getPixelHeights(tableGrid);

				let newHeights = [],
					newTotalHeight = 0;

				for (let i = 0; i < heights.length; i++) {
					newHeights.push(i === index ? delta + heights[i] : heights[i]);
					newTotalHeight += newTotalHeight[i];
				}

				const newCellSizes = recalculateCellHeights(tableGrid, newHeights);
				const newRowSizes = recalculateRowHeights(tableGrid, newHeights);

				editor.undoManager.transact(function () {
					Tools.each(newRowSizes, function (row) {
						editor.dom.setStyle(row.element, "height", row.height + "px");
						editor.dom.setAttrib(row.element, "height", null);
					});

					Tools.each(newCellSizes, function (cell) {
						editor.dom.setStyle(cell.element, "height", cell.height + "px");
						editor.dom.setAttrib(cell.element, "height", null);
					});

					editor.dom.setStyle(table, "height", newTotalHeight + "px");
					editor.dom.setAttrib(table, "height", null);
				});
			}

			function scheduleDelayedDropEvent() {
				delayDrop = setTimeout(function () {
					drop();
				}, 200);
			}

			function cancelDelayedDropEvent() {
				clearTimeout(delayDrop);
			}

			function getBlockerElement() {
				const blocker = document.createElement("div");

				blocker.setAttribute(
					"style",
					"margin: 0; " +
						"padding: 0; " +
						"position: fixed; " +
						"left: 0px; " +
						"top: 0px; " +
						"height: 100%; " +
						"width: 100%;"
				);
				blocker.setAttribute("data-mce-bogus", "all");

				return blocker;
			}

			function bindBlockerEvents(blocker, dragHandler) {
				editor.dom.bind(blocker, "mouseup", function () {
					drop();
				});

				editor.dom.bind(blocker, "mousemove", function (e) {
					cancelDelayedDropEvent();

					if (dragging) {
						dragHandler(e);
					}
				});

				editor.dom.bind(blocker, "mouseout", function () {
					scheduleDelayedDropEvent();
				});
			}

			function drop() {
				editor.dom.remove(blockerElement);

				if (dragging) {
					editor.dom.removeClass(dragBar, RESIZE_BAR_DRAGGING_CLASS);
					dragging = false;

					let index, delta;

					if (isCol(dragBar)) {
						const initialLeft = parseInt(editor.dom.getAttrib(dragBar, RESIZE_BAR_COL_DATA_INITIAL_LEFT_ATTRIBUTE), 10);
						const newLeft = editor.dom.getPos(dragBar).x;
						index = parseInt(editor.dom.getAttrib(dragBar, RESIZE_BAR_COL_DATA_ATTRIBUTE), 10);
						delta = isRtl() ? initialLeft - newLeft : newLeft - initialLeft;
						if (Math.abs(delta) >= 1) {
							// simple click with no real resize (<1px) must not add CSS properties
							adjustWidth(hoverTable, delta, index);
						}
					} else if (isRow(dragBar)) {
						const initialTop = parseInt(editor.dom.getAttrib(dragBar, RESIZE_BAR_ROW_DATA_INITIAL_TOP_ATTRIBUTE), 10);
						const newTop = editor.dom.getPos(dragBar).y;
						index = parseInt(editor.dom.getAttrib(dragBar, RESIZE_BAR_ROW_DATA_ATTRIBUTE), 10);
						delta = newTop - initialTop;
						if (Math.abs(delta) >= 1) {
							// simple click with no real resize (<1px) must not add CSS properties
							adjustHeight(hoverTable, delta, index);
						}
					}
					refreshBars(hoverTable);
					editor.nodeChanged();
				}
			}

			function setupBaseDrag(bar, dragHandler) {
				blockerElement = blockerElement ? blockerElement : getBlockerElement();
				dragging = true;
				editor.dom.addClass(bar, RESIZE_BAR_DRAGGING_CLASS);
				dragBar = bar;
				bindBlockerEvents(blockerElement, dragHandler);
				editor.dom.add(getBody(), blockerElement);
			}

			function isCol(target) {
				return editor.dom.hasClass(target, RESIZE_BAR_COL_CLASS);
			}

			function isRow(target) {
				return editor.dom.hasClass(target, RESIZE_BAR_ROW_CLASS);
			}

			function colDragHandler(event) {
				lastX = lastX !== undefined ? lastX : event.clientX; // we need a firstX
				const deltaX = event.clientX - lastX;
				lastX = event.clientX;
				const oldLeft = editor.dom.getPos(dragBar).x;
				editor.dom.setStyle(dragBar, "left", oldLeft + deltaX + "px");
			}

			function rowDragHandler(event) {
				lastY = lastY !== undefined ? lastY : event.clientY;
				const deltaY = event.clientY - lastY;
				lastY = event.clientY;
				const oldTop = editor.dom.getPos(dragBar).y;
				editor.dom.setStyle(dragBar, "top", oldTop + deltaY + "px");
			}

			function setupColDrag(bar) {
				lastX = undefined;
				setupBaseDrag(bar, colDragHandler);
			}

			function setupRowDrag(bar) {
				lastY = undefined;
				setupBaseDrag(bar, rowDragHandler);
			}

			function mouseDownHandler(e) {
				const target = e.target,
					body = editor.getBody();

				// Since this code is working on global events we need to work on a global hoverTable state
				// and make sure that the state is correct according to the events fired
				if (!editor.$.contains(body, hoverTable) && hoverTable !== body) {
					return;
				}

				if (isCol(target)) {
					e.preventDefault();
					const initialLeft = editor.dom.getPos(target).x;
					editor.dom.setAttrib(target, RESIZE_BAR_COL_DATA_INITIAL_LEFT_ATTRIBUTE, initialLeft);
					setupColDrag(target);
				} else if (isRow(target)) {
					e.preventDefault();
					const initialTop = editor.dom.getPos(target).y;
					editor.dom.setAttrib(target, RESIZE_BAR_ROW_DATA_INITIAL_TOP_ATTRIBUTE, initialTop);
					setupRowDrag(target);
				} else {
					clearBars();
				}
			}

			editor.on("init", function () {
				// Needs to be like this for inline mode, editor.on does not bind to elements in the document body otherwise
				editor.dom.bind(getBody(), "mousedown", mouseDownHandler);
			});

			// If we're updating the table width via the old mechanic, we need to update the constituent cells' widths/heights too.
			editor.on("ObjectResized", function (e) {
				const table = e.target;
				if (table.nodeName === "TABLE") {
					const newCellSizes = [];
					Tools.each(table.rows, function (row) {
						Tools.each(row.cells, function (cell) {
							const width = editor.dom.getStyle(cell, "width", true);
							newCellSizes.push({
								cell: cell,
								width: width,
							});
						});
					});
					Tools.each(newCellSizes, function (newCellSize) {
						editor.dom.setStyle(newCellSize.cell, "width", newCellSize.width);
						editor.dom.setAttrib(newCellSize.cell, "width", null);
					});
				}
			});

			editor.on("mouseover", function (e) {
				if (!dragging) {
					const tableElement = editor.dom.getParent(e.target, "table");

					if (e.target.nodeName === "TABLE" || tableElement) {
						hoverTable = tableElement;
						refreshBars(tableElement);
					}
				}
			});

			// Prevents the user from moving the caret inside the resize bars on Chrome
			// Only does it on arrow keys since clearBars might be an epxensive operation
			// since it's querying the DOM
			editor.on("keydown", function (e) {
				switch (e.keyCode) {
					case VK.LEFT:
					case VK.RIGHT:
					case VK.UP:
					case VK.DOWN:
						clearBars();
						break;
				}
			});

			editor.on("remove", function () {
				clearBars();
				editor.dom.unbind(getBody(), "mousedown", mouseDownHandler);
			});

			return {
				adjustWidth: adjustWidth,
				adjustHeight: adjustHeight,
				clearBars: clearBars,
				drawBars: drawBars,
				determineDeltas: determineDeltas,
				getTableGrid: getTableGrid,
				getTableDetails: getTableDetails,
				getWidths: getWidths,
				getPixelHeights: getPixelHeights,
				isPercentageBasedSize: isPercentageBasedSize,
				isPixelBasedSize: isPixelBasedSize,
				recalculateWidths: recalculateWidths,
				recalculateCellHeights: recalculateCellHeights,
				recalculateRowHeights: recalculateRowHeights,
			};
		};
	});

	// Included from: js/tinymce/plugins/table/classes/Plugin.js

	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2015 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */

	/**
	 * This class contains all core logic for the table plugin.
	 * @class tinymce.tableplugin.Plugin
	 * @private
	 */
	define("tinymce/tableplugin/Plugin", [
		"tinymce/tableplugin/TableGrid",
		"tinymce/tableplugin/Quirks",
		"tinymce/tableplugin/CellSelection",
		"tinymce/tableplugin/Dialogs",
		"tinymce/tableplugin/ResizeBars",
		"tinymce/util/Tools",
		"tinymce/dom/TreeWalker",
		"tinymce/Env",
		"tinymce/PluginManager",
	], function (TableGrid, Quirks, CellSelection, Dialogs, ResizeBars, Tools, TreeWalker, Env, PluginManager) {
		const each = Tools.each;

		function Plugin(editor) {
			let clipboardRows,
				self = this,
				dialogs = new Dialogs(editor),
				resizeBars;

			if (
				editor.settings.object_resizing &&
				editor.settings.table_resize_bars !== false &&
				(editor.settings.object_resizing === true || editor.settings.object_resizing === "table")
			) {
				resizeBars = ResizeBars(editor);
			}

			function cmd(command) {
				return function () {
					editor.execCommand(command);
				};
			}

			function insertTable(cols, rows) {
				let y, x, html, tableElm;

				html = '<table id="__mce"><tbody>';

				for (y = 0; y < rows; y++) {
					html += "<tr>";

					for (x = 0; x < cols; x++) {
						html += "<td>" + (Env.ie && Env.ie < 10 ? "&nbsp;" : "<br>") + "</td>";
					}

					html += "</tr>";
				}

				html += "</tbody></table>";

				editor.undoManager.transact(function () {
					editor.insertContent(html);

					tableElm = editor.dom.get("__mce");
					editor.dom.setAttrib(tableElm, "id", null);

					editor.$("tr", tableElm).each(function (index, row) {
						editor.fire("newrow", {
							node: row,
						});

						editor.$("th,td", row).each(function (index, cell) {
							editor.fire("newcell", {
								node: cell,
							});
						});
					});

					editor.dom.setAttribs(tableElm, editor.settings.table_default_attributes || {});
					editor.dom.setStyles(tableElm, editor.settings.table_default_styles || {});
				});

				return tableElm;
			}

			function handleDisabledState(ctrl, selector, sameParts) {
				function bindStateListener() {
					let selectedElm,
						selectedCells,
						parts = {},
						sum = 0,
						state;

					selectedCells = editor.dom.select("td[data-mce-selected],th[data-mce-selected]");
					selectedElm = selectedCells[0];
					if (!selectedElm) {
						selectedElm = editor.selection.getStart();
					}

					// Make sure that we don't have a selection inside thead and tbody at the same time
					if (sameParts && selectedCells.length > 0) {
						each(selectedCells, function (cell) {
							return (parts[cell.parentNode.parentNode.nodeName] = 1);
						});

						each(parts, function (value) {
							sum += value;
						});

						state = sum !== 1;
					} else {
						state = !editor.dom.getParent(selectedElm, selector);
					}

					ctrl.disabled(state);

					editor.selection.selectorChanged(selector, function (state) {
						ctrl.disabled(!state);
					});
				}

				if (editor.initialized) {
					bindStateListener();
				} else {
					editor.on("init", bindStateListener);
				}
			}

			function postRender() {
				handleDisabledState(this, "table");
			}

			function postRenderCell() {
				handleDisabledState(this, "td,th");
			}

			function postRenderDeleteCell() {
				let button;

				// Потому что из двух мест, основной тулбар и всплывающий для таблицы
				if (Object.hasOwn(this, "control")) {
					// в выпадающем списке
					button = this.control;
				} else {
					// во всплывающем меню
					button = this;
				}

				setButtonCellDeleteState(button);

				editor.on("click", function () {
					setButtonCellDeleteState(button);
				});

				editor.on("change", function () {
					setButtonCellDeleteState(button);
				});
			}

			function setButtonCellDeleteState(button) {
				let buttonState = true;
				const table = editor.dom.getParent(editor.selection.getNode(), "table");

				if (table) {
					buttonState = table.innerHTML.includes("colspan") || table.innerHTML.includes("rowspan");
				}

				button.disabled(buttonState);
			}

			function postRenderMergeCell() {
				handleDisabledState(this, "td,th", true);
			}

			function generateTableGrid() {
				let html = "";

				html = '<table role="grid" class="mce-grid mce-grid-border" aria-readonly="true">';

				for (let y = 0; y < 10; y++) {
					html += "<tr>";

					for (let x = 0; x < 10; x++) {
						html +=
							'<td role="gridcell" tabindex="-1"><a id="mcegrid' +
							(y * 10 + x) +
							'" href="#" ' +
							'data-mce-x="' +
							x +
							'" data-mce-y="' +
							y +
							'"></a></td>';
					}

					html += "</tr>";
				}

				html += "</table>";

				html += '<div class="mce-text-center" role="presentation">1 x 1</div>';

				return html;
			}

			function selectGrid(tx, ty, control) {
				const table = control.getEl().getElementsByTagName("table")[0];
				let x, y, focusCell, cell, active;
				const rtl = control.isRtl() || control.parent().rel === "tl-tr";

				table.nextSibling.innerHTML = tx + 1 + " x " + (ty + 1);

				if (rtl) {
					tx = 9 - tx;
				}

				for (y = 0; y < 10; y++) {
					for (x = 0; x < 10; x++) {
						cell = table.rows[y].childNodes[x].firstChild;
						active = (rtl ? x >= tx : x <= tx) && y <= ty;

						editor.dom.toggleClass(cell, "mce-active", active);

						if (active) {
							focusCell = cell;
						}
					}
				}

				return focusCell.parentNode;
			}

			if (editor.settings.table_grid === false) {
				editor.addMenuItem("inserttable", {
					text: "Table",
					icon: "table",
					context: "table",
					onclick: dialogs.table,
				});
			} else {
				editor.addMenuItem("inserttable", {
					text: "Table",
					icon: "table",
					context: "table",
					ariaHideMenu: true,
					onclick: function (e) {
						if (e.aria) {
							this.parent().hideAll();
							e.stopImmediatePropagation();
							dialogs.table();
						}
					},
					onshow: function () {
						selectGrid(0, 0, this.menu.items()[0]);
					},
					onhide: function () {
						const elements = this.menu.items()[0].getEl().getElementsByTagName("a");
						editor.dom.removeClass(elements, "mce-active");
						editor.dom.addClass(elements[0], "mce-active");
					},
					menu: [
						{
							type: "container",
							html: generateTableGrid(),

							onPostRender: function () {
								this.lastX = this.lastY = 0;
							},

							onmousemove: function (e) {
								let target = e.target,
									x,
									y;

								if (target.tagName.toUpperCase() === "A") {
									x = parseInt(target.getAttribute("data-mce-x"), 10);
									y = parseInt(target.getAttribute("data-mce-y"), 10);

									if (this.isRtl() || this.parent().rel === "tl-tr") {
										x = 9 - x;
									}

									if (x !== this.lastX || y !== this.lastY) {
										selectGrid(x, y, e.control);

										this.lastX = x;
										this.lastY = y;
									}
								}
							},

							onclick: function (e) {
								const self = this;

								if (e.target.tagName.toUpperCase() === "A") {
									e.preventDefault();
									e.stopPropagation();
									self.parent().cancel();

									editor.undoManager.transact(function () {
										insertTable(self.lastX + 1, self.lastY + 1);
									});

									editor.addVisual();
								}
							},
						},
					],
				});
			}

			editor.addMenuItem("tableprops", {
				text: "Table properties",
				context: "table",
				onPostRender: postRender,
				onclick: dialogs.tableProps,
			});

			editor.addMenuItem("deletetable", {
				text: "Delete table",
				context: "table",
				onPostRender: postRender,
				cmd: "mceTableDelete",
			});

			editor.addMenuItem("cell", {
				separator: "before",
				text: "Cell",
				context: "table",
				menu: [
					{ text: "Cell properties", onclick: cmd("mceTableCellProps"), onPostRender: postRenderCell },
					{ text: "Merge cells", onclick: cmd("mceTableMergeCells"), onPostRender: postRenderMergeCell },
					{ text: "Split cell", onclick: cmd("mceTableSplitCells"), onPostRender: postRenderCell },
					{ text: "Delete cell", onclick: cmd("mceTableDeleteCell"), onPostRender: postRenderDeleteCell },
				],
			});

			editor.addMenuItem("row", {
				text: "Row",
				context: "table",
				menu: [
					{ text: "Insert row before", onclick: cmd("mceTableInsertRowBefore"), onPostRender: postRenderCell },
					{ text: "Insert row after", onclick: cmd("mceTableInsertRowAfter"), onPostRender: postRenderCell },
					{ text: "Delete row", onclick: cmd("mceTableDeleteRow"), onPostRender: postRenderCell },
					{ text: "Row properties", onclick: cmd("mceTableRowProps"), onPostRender: postRenderCell },
					{ text: "-" },
					{ text: "Cut row", onclick: cmd("mceTableCutRow"), onPostRender: postRenderCell },
					{ text: "Copy row", onclick: cmd("mceTableCopyRow"), onPostRender: postRenderCell },
					{ text: "Paste row before", onclick: cmd("mceTablePasteRowBefore"), onPostRender: postRenderCell },
					{ text: "Paste row after", onclick: cmd("mceTablePasteRowAfter"), onPostRender: postRenderCell },
				],
			});

			editor.addMenuItem("column", {
				text: "Column",
				context: "table",
				menu: [
					{ text: "Insert column before", onclick: cmd("mceTableInsertColBefore"), onPostRender: postRenderCell },
					{ text: "Insert column after", onclick: cmd("mceTableInsertColAfter"), onPostRender: postRenderCell },
					{ text: "Delete column", onclick: cmd("mceTableDeleteCol"), onPostRender: postRenderCell },
					{ text: "Col properties", onclick: cmd("mceTableColProps"), onPostRender: postRenderCell },
				],
			});

			const menuItems = [];
			each("inserttable tableprops deletetable | cell row column".split(" "), function (name) {
				if (name === "|") {
					menuItems.push({ text: "-" });
				} else {
					menuItems.push(editor.menuItems[name]);
				}
			});

			editor.addButton("table", {
				type: "menubutton",
				title: "Table",
				menu: menuItems,
			});

			// Select whole table is a table border is clicked
			if (!Env.isIE) {
				editor.on("click", function (e) {
					if (e.target.nodeName === "TABLE") {
						editor.selection.select(e.target);
						editor.nodeChanged();
					}
				});
			}

			self.quirks = new Quirks(editor);

			editor.on("Init", function () {
				self.cellSelection = new CellSelection(editor, function (selecting) {
					if (selecting && resizeBars) {
						resizeBars.clearBars();
					}
				});
				self.resizeBars = resizeBars;
			});

			editor.on("PreInit", function () {
				// Remove internal data attributes
				editor.serializer.addAttributeFilter(
					"data-mce-cell-padding,data-mce-border,data-mce-border-color",
					function (nodes, name) {
						let i = nodes.length;

						while (i--) {
							nodes[i].attr(name, null);
						}
					}
				);
			});

			// Register action commands
			each(
				{
					mceTableSplitCells: function (grid) {
						grid.split();
					},

					mceTableMergeCells: function (grid) {
						let cell;

						cell = editor.dom.getParent(editor.selection.getStart(), "th,td");

						if (!editor.dom.select("td[data-mce-selected],th[data-mce-selected]").length) {
							dialogs.merge(grid, cell);
						} else {
							grid.merge();
						}
					},

					mceTableDeleteCell: function (grid) {
						const cell = editor.dom.getParent(editor.selection.getStart(), "th,td");
						grid.deleteCell(cell);
					},

					mceTableInsertRowBefore: function (grid) {
						grid.insertRows(true);
					},

					mceTableInsertRowAfter: function (grid) {
						grid.insertRows();
					},

					mceTableInsertColBefore: function (grid) {
						grid.insertCols(true);
					},

					mceTableInsertColAfter: function (grid) {
						grid.insertCols();
					},

					mceTableDeleteCol: function (grid) {
						grid.deleteCols();
					},

					mceTableColsHeader: function (grid) {
						grid.colsHeader();
					},

					mceTableDeleteRow: function (grid) {
						grid.deleteRows();
					},

					mceTableCutRow: function (grid) {
						clipboardRows = grid.cutRows();
					},

					mceTableCopyRow: function (grid) {
						clipboardRows = grid.copyRows();
					},

					mceTablePasteRowBefore: function (grid) {
						grid.pasteRows(clipboardRows, true);
					},

					mceTablePasteRowAfter: function (grid) {
						grid.pasteRows(clipboardRows);
					},

					mceSplitColsBefore: function (grid) {
						grid.splitCols(true);
					},

					mceSplitColsAfter: function (grid) {
						grid.splitCols(false);
					},

					mceTableDelete: function (grid) {
						if (resizeBars) {
							resizeBars.clearBars();
						}
						grid.deleteTable();
					},
				},
				function (func, name) {
					editor.addCommand(name, function () {
						const grid = new TableGrid(editor);

						if (grid) {
							func(grid);
							editor.execCommand("mceRepaint");
							self.cellSelection.clear();
						}
					});
				}
			);

			// Register dialog commands
			each(
				{
					mceInsertTable: dialogs.table,
					mceTableProps: function () {
						dialogs.table(true);
					},
					mceTableRowProps: dialogs.row,
					mceTableColProps: dialogs.col,
					mceTableCellProps: dialogs.cell,
				},
				function (func, name) {
					editor.addCommand(name, function (ui, val) {
						func(val);
					});
				}
			);

			function addButtons() {
				editor.addButton("tableprops", {
					title: "Table properties",
					onclick: dialogs.tableProps,
					icon: "table",
				});

				editor.addButton("tabledelete", {
					title: "Delete table",
					onclick: cmd("mceTableDelete"),
				});

				editor.addButton("tablecellprops", {
					title: "Cell properties",
					onclick: cmd("mceTableCellProps"),
				});

				editor.addButton("tablemergecells", {
					title: "Merge cells",
					onclick: cmd("mceTableMergeCells"),
				});

				editor.addButton("tablesplitcells", {
					title: "Split cell",
					onclick: cmd("mceTableSplitCells"),
				});

				editor.addButton("tabledeletecell", {
					title: "Delete cell",
					onclick: cmd("mceTableDeleteCell"),
					onpostrender: postRenderDeleteCell,
				});

				editor.addButton("tableinsertrowbefore", {
					title: "Insert row before",
					onclick: cmd("mceTableInsertRowBefore"),
				});

				editor.addButton("tableinsertrowafter", {
					title: "Insert row after",
					onclick: cmd("mceTableInsertRowAfter"),
				});

				editor.addButton("tabledeleterow", {
					title: "Delete row",
					onclick: cmd("mceTableDeleteRow"),
				});

				editor.addButton("tablerowprops", {
					title: "Row properties",
					onclick: cmd("mceTableRowProps"),
				});

				editor.addButton("tablecolprops", {
					title: "Col properties",
					onclick: cmd("mceTableColProps"),
				});

				editor.addButton("tablecutrow", {
					title: "Cut row",
					onclick: cmd("mceTableCutRow"),
				});

				editor.addButton("tablecopyrow", {
					title: "Copy row",
					onclick: cmd("mceTableCopyRow"),
				});

				editor.addButton("tablepasterowbefore", {
					title: "Paste row before",
					onclick: cmd("mceTablePasteRowBefore"),
				});

				editor.addButton("tablepasterowafter", {
					title: "Paste row after",
					onclick: cmd("mceTablePasteRowAfter"),
				});

				editor.addButton("tableinsertcolbefore", {
					title: "Insert column before",
					onclick: cmd("mceTableInsertColBefore"),
				});

				editor.addButton("tableinsertcolafter", {
					title: "Insert column after",
					onclick: cmd("mceTableInsertColAfter"),
				});

				editor.addButton("tabledeletecol", {
					title: "Delete column",
					onclick: cmd("mceTableDeleteCol"),
				});
			}

			function isTable(table) {
				const selectorMatched = editor.dom.is(table, "table") && editor.getBody().contains(table);

				return selectorMatched;
			}

			function addToolbars() {
				let toolbarItems = editor.settings.table_toolbar;

				if (toolbarItems === "" || toolbarItems === false) {
					return;
				}

				if (!toolbarItems) {
					toolbarItems =
						"tableprops tabledelete | " +
						"tableinsertrowbefore tableinsertrowafter tabledeleterow | " +
						"tableinsertcolbefore tableinsertcolafter tabledeletecol | " +
						"tablemergecells tablesplitcells tabledeletecell";
				}

				editor.addContextToolbar(isTable, toolbarItems);
			}

			function getClipboardRows() {
				return clipboardRows;
			}

			function setClipboardRows(rows) {
				clipboardRows = rows;
			}

			addButtons();
			addToolbars();

			// Enable tab key cell navigation
			if (editor.settings.table_tab_navigation !== false) {
				editor.on("keydown", function (e) {
					let cellElm, grid, delta;

					if (e.keyCode === 9) {
						cellElm = editor.dom.getParent(editor.selection.getStart(), "th,td");

						if (cellElm) {
							e.preventDefault();

							grid = new TableGrid(editor);
							delta = e.shiftKey ? -1 : 1;

							editor.undoManager.transact(function () {
								if (!grid.moveRelIdx(cellElm, delta) && delta > 0) {
									grid.insertRow();
									grid.refresh();
									grid.moveRelIdx(cellElm, delta);
								}
							});
						}
					}
				});
			}

			self.insertTable = insertTable;
			self.setClipboardRows = setClipboardRows;
			self.getClipboardRows = getClipboardRows;
		}

		PluginManager.add("table", Plugin);
	});
})(window);
